import Service from '../service/Service';
import Cookies from "js-cookie";

import { createElement } from 'react';
const service = new Service();
var _selectedvalgender = [];
var _selectedvalreligion = [];
var _selectedvalnumerology = [];
var _selectedvalrashi = [];
var _selectedvalnakshatra = [];
var _selectedvalstarting = [];
var _selectedvalgod = [];
var _selectedvalorigin = [];
var checkedparent, subcat_count;
var searchedname = '';
var selcted_cat, subcatarray = [];
var _appliedDataOnly = [];
var catvalArr = [];
var result = [];
var local_base_url = "/baby-names/";
var babynameId_array = [];

export function scrollToTop(){
    let element = document.documentElement;
    let to = 0;
    let duration = 500;

    var start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;
    var easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    };

    var animateScroll = function () {
        currentTime += increment;
        var val = easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}
export function todesksearch(el){
    var url = "/baby-names/finder/";
    el.props.history.push(service.getRedirectUrl(url)) ;
}

export function checkfiltersubcat(event) {
    event.preventDefault();
    var children_classarray = event.currentTarget.children;
    if(children_classarray[0].classList.contains('isChecked')){
        children_classarray[0].classList.remove("isChecked");
        children_classarray[1].classList.remove("isChecked");
        children_classarray[0].setAttribute("data-icon-font", "z");
    } else {
        children_classarray[0].classList += " isChecked";
        children_classarray[1].classList += " isChecked";
        children_classarray[0].setAttribute("data-icon-font", "A");
    }

    if(Cookies.get('all_filters') == "true"){
        var el = event.target.parentElement;
        while(el.className.split(" ")[1] != 'subcategorieslist'){
            el = el.parentElement;
        }
        checkedparent = el.classList;
        
        subcat_count = document.querySelector("." + checkedparent[0]).querySelectorAll(".subcatname.isChecked").length;

        if (subcat_count > 0) {
            document.querySelector(".categorieslist").querySelector(".active").querySelector(".subcatCount").innerHTML = (subcat_count + " Selected");
        }
        else {
            document.querySelector(".categorieslist").querySelector(".active").querySelector(".subcatCount").innerHTML = '';
        }
    }
}

export function cancelpopup(event) {
    event.preventDefault();
    document.getElementsByTagName('body')[0].style.overflow = 'unset';
    var el = event.target.parentElement;
    
    while(el.className.split(" ")[1] != 'overlay'){
        el = el.parentElement;
    }

    if(localStorage.getItem('all_filters') !== "true"){
        var inputs = el.getElementsByClassName('filter_popups')[0].getElementsByTagName('li');
        for (var i = 0; i < inputs.length; i++) {
            if(inputs[i].classList.contains("applied")){
                if(!inputs[i].querySelector('.check').classList.contains("isChecked")){
                    inputs[i].querySelector('.check').classList += " isChecked";
                    inputs[i].getElementsByClassName('check')[0] && inputs[i].getElementsByClassName('check')[0].setAttribute("data-icon-font", "A");
                }
                if(!inputs[i].querySelector('.genName').classList.contains("isChecked")){
                    inputs[i].querySelector('.genName').classList += " isChecked";
                }
                
                var appliedValue = inputs[i].getElementsByClassName("genName")[0].innerHTML;
                _appliedDataOnly.push(appliedValue);
            } else {
                var elems = inputs[i].querySelectorAll(".isChecked");
                [].forEach.call(elems, function(el) {
                    el.className = el.className.replace(/\isChecked\b/, "");
                });
                
                inputs[i].getElementsByClassName('check')[0] && inputs[i].getElementsByClassName('check')[0].setAttribute("data-icon-font", "z");
            }
        }
    } else {
        var all_filters_list = el.getElementsByClassName('filter_popups')[0].getElementsByClassName('subcategorieslist');
        for(var j=0; j < all_filters_list.length; j++){

            var inputs = all_filters_list[j].getElementsByTagName('li');
            for (var i = 0; i < inputs.length; i++) {
               
                if(inputs[i].classList.contains("applied")){
                    if(!inputs[i].querySelector('.check').classList.contains("isChecked")){
                        inputs[i].querySelector('.check').classList += " isChecked";
                        inputs[i].getElementsByClassName('check')[0] && inputs[i].getElementsByClassName('check')[0].setAttribute("data-icon-font", "A");
                    }
                    if(!inputs[i].querySelector('.subcatname').classList.contains("isChecked")){
                        inputs[i].querySelector('.subcatname').classList += " isChecked";
                    }
                    
                } else {
                    var elems = inputs[i].querySelectorAll(".isChecked");
                    [].forEach.call(elems, function(el) {
                        el.className = el.className.replace(/\isChecked\b/, "");
                    });
                    inputs[i].getElementsByClassName('check')[0] && inputs[i].getElementsByClassName('check')[0].setAttribute("data-icon-font", "z");
                }
            }
        }
    }
    
    localStorage.setItem('all_filters', false);
    Cookies.set('all_filters', false);
    el.style.display = 'none';

    document.getElementById("sabcat_search").value = '';
}

export function clearAll(event){
    event.preventDefault();
    document.getElementsByTagName('body')[0].style.overflow = 'unset';
    var el = event.target.parentElement;
    
    while(el.className.split(" ")[1] != 'overlay'){
        el = el.parentElement;
    }

    var all_filters_list = el.getElementsByClassName('filter_popups')[0].getElementsByClassName('subcategorieslist');
   
    for(var j=0; j < all_filters_list.length; j++){

        var inputs = all_filters_list[j].getElementsByTagName('li');
        for (var i = 0; i < inputs.length; i++) {
            
            var elems = inputs[i].querySelectorAll(".isChecked");
            [].forEach.call(elems, function(el) {
                el.className = el.className.replace(/\isChecked\b/, "");
            });

            inputs[i].getElementsByClassName('check')[0] && inputs[i].getElementsByClassName('check')[0].setAttribute("data-icon-font", "z");
        }
    }
    var _selectedtext = document.querySelectorAll(".subcatCount");
    
    [].forEach.call(_selectedtext, function(el){
        if(el.innerHTML != ''){
            el.innerHTML = '';
        }
    });
    if(document.querySelector(".gender_filter")){
        var _prefilterGender = document.querySelector(".gender_filter").querySelector(".selected_filter");

        if(_prefilterGender.innerHTML !== "Gender"){
            _prefilterGender.innerHTML = "Gender";
        }

        var _prefilterReligion = document.querySelector(".religion_filter").querySelector(".selected_filter");
        
        if(_prefilterReligion.innerHTML !== "Religion"){
            _prefilterReligion.innerHTML = "Religion";
        }

        var _prefilterNumerology = document.querySelector(".origin_filter").querySelector(".selected_filter");
        
        if(_prefilterNumerology.innerHTML !== "Origin"){
            _prefilterNumerology.innerHTML = "Origin";
        }

        var _prefilterRashi = document.querySelector(".rashi_filter").querySelector(".selected_filter");
        
        if(_prefilterRashi.innerHTML !== "Rashi"){
            _prefilterRashi.innerHTML = "Rashi";
        }
    }
    var _prefilterpopups = document.querySelectorAll(".filter_popups");

    for(var j=0; j < _prefilterpopups.length; j++){
        
        var inputs = _prefilterpopups[j].getElementsByTagName('li');
        
        for (var i = 0; i < inputs.length; i++) {
            
            if(inputs[i].classList.contains("applied")) {
                inputs[i].className = inputs[i].className.replace(/\applied\b/, "");
                var _elems = inputs[i].querySelectorAll(".isChecked");
                [].forEach.call(_elems, function(el) {
                    el.className = el.className.replace(/\isChecked\b/, "");
                });
                
                inputs[i].getElementsByClassName('check')[0] && inputs[i].getElementsByClassName('check')[0].setAttribute("data-icon-font", "z");
            }
        }
    }

}
export function mysearchlist() {
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById("sabcat_search");
    filter = input.value.toUpperCase();
    ul = document.getElementsByClassName("subcategorieslist");
    for (var k = 0; k < ul.length; k++) {
        li = ul[k].getElementsByTagName("li");
        for (var i = 0; i < li.length; i++) {
            a = li[i].querySelectorAll(".subcatname");
           
            [].forEach.call(a, function(ele){
                if(ele.innerHTML.toUpperCase().indexOf(filter) > -1){
                    li[i].style.display = "block";
                } else {
                    li[i].style.display = "none";
                }
            })
        }
    }
}

export function applypopup(event) {
    event.preventDefault();
    document.getElementsByTagName('body')[0].style.overflow = 'unset';
    var el = event.target.parentElement;
    
    while(el.className.split(" ")[1] != 'overlay'){
        el = el.parentElement;
    }
    if(el.getElementsByClassName('filter_popups')[0].classList.contains('gender_popup')){
        applysubcat(event, "gender_popup", _selectedvalgender, "gender_filter", "subgender", "Gender")
    }if(el.getElementsByClassName('filter_popups')[0].classList.contains('religion_popup')){
        applysubcat(event, "religion_popup", _selectedvalreligion, "religion_filter", "subreligion", "Religion");
    }if(el.getElementsByClassName('filter_popups')[0].classList.contains('origin_popup')){
        applysubcat(event, "origin_popup", _selectedvalorigin, "origin_filter", "suborigin", "Origin")
    }if(el.getElementsByClassName('filter_popups')[0].classList.contains('rashi_popup')){
        applysubcat(event, "rashi_popup", _selectedvalrashi, "rashi_filter", "subrashi", "Rashi")
    }
   
     Cookies.set('selectedvalgender', _selectedvalgender);
     Cookies.set('selectedvalreligion', _selectedvalreligion);
     Cookies.set('selectedvalnumerology', _selectedvalnumerology);
     Cookies.set('selectedvalrashi', _selectedvalrashi);
     Cookies.set('selectedvalnakshatra', _selectedvalnakshatra);
     Cookies.set('selectedvalstarting', _selectedvalstarting);
     Cookies.set('selectedvalgod', _selectedvalgod);
     Cookies.set('selectedvalorigin', _selectedvalorigin);

     localStorage.setItem('selectedvalgender', _selectedvalgender);
     localStorage.setItem('selectedvalreligion', _selectedvalreligion);
     localStorage.setItem('selectedvalnumerology', _selectedvalnumerology);
     localStorage.setItem('selectedvalrashi', _selectedvalrashi);
     localStorage.setItem('selectedvalnakshatra', _selectedvalnakshatra);
     localStorage.setItem('selectedvalstarting', _selectedvalstarting);
     localStorage.setItem('selectedvalgod', _selectedvalgod);
     localStorage.setItem('selectedvalorigin', _selectedvalorigin);

     localStorage.setItem('searchedname', searchedname);

    el.style.display = 'none';
}

function applysubcat(event, cat_popup, catvalArr, catFilter, subcat, catname) {
    event.preventDefault();
    var _onlyRashiNameArray=[];
    var el = event.target.parentElement;
    
    while(el.className.split(" ")[1] != 'overlay'){
        el = el.parentElement;
    }
    
    var _checked = el.getElementsByClassName(cat_popup)[0].getElementsByClassName('R14_42 isChecked');
    
    if (_checked.length > 0) {
        catvalArr = [];
        var elems = el.getElementsByClassName(cat_popup)[0].querySelectorAll('li');
        
        [].forEach.call(elems, function(el) {
            el.className = el.className.replace(/\applied\b/, "");
        });
            for (var i = 0; i < _checked.length; i++) {
            
            _checked[i].parentElement.classList += " applied";
            
            var onlycatg = _checked[i];
            var onlysecond = onlycatg.innerHTML;
            catvalArr.push(onlysecond);
            }
        
    } else {
        catvalArr = [];
        var elems = el.getElementsByClassName(cat_popup)[0].getElementsByTagName('li');
                    
        [].forEach.call(elems, function(el) {
            el.className = el.className.replace(/\applied\b/, "");
        });

        document.querySelector("." + catFilter).querySelector(".selected_filter").innerHTML = catname;
    }
    
    if(catvalArr.length > 0) {
        var subcat_lis = document.querySelectorAll('.' + subcat)[0].getElementsByTagName("li");
        
        for(var j=0;j<subcat_lis.length;j++){
            subcat_lis[j].className = subcat_lis[j].className.replace(/\applied\b/, "");
            
            [].forEach.call(subcat_lis[j].querySelectorAll("span"), function(el){
                
                el.className = el.className.replace(/\isChecked\b/, "");
                if(el.classList.contains('icon')){
                    el.setAttribute("data-icon-font", "z");
                }
            })
        }

        for (var i = 0; i < catvalArr.length; i++) {
            if (cat_popup == "rashi_popup") {
                var rashi = catvalArr[i];
                var onlyrashi = rashi.split(" ")[0];
                
                _onlyRashiNameArray.push(onlyrashi);
                document.querySelector("." + catFilter).querySelector(".selected_filter").innerHTML = onlyrashi;
                var subcat_ele = document.querySelectorAll('.' + subcat)[0].getElementsByTagName("li");

                for(var j=0;j<subcat_lis.length;j++){
                    if(subcat_lis[j].querySelector(".subcatname").innerHTML == catvalArr[i]){

                        subcat_lis[j].className += " applied";
                        subcat_lis[j].querySelector(".icon").className += " isChecked";
                        subcat_lis[j].querySelector(".icon").setAttribute("data-icon-font", "A");
                        subcat_lis[j].querySelector(".subcatname").className += " isChecked";
                    }
                }
            } else {
                var subcat_ele = document.querySelectorAll('.' + subcat)[0].getElementsByTagName("li");
                document.querySelector("." + catFilter).querySelector(".selected_filter").innerHTML = catvalArr[0];

                for(var j=0;j<subcat_lis.length;j++){
                    if(subcat_lis[j].querySelector(".subcatname").innerHTML == (catvalArr[i])){
                        subcat_lis[j].className += " applied";
                        
                        subcat_lis[j].querySelector(".icon").className += " isChecked";
                        subcat_lis[j].querySelector(".icon").setAttribute("data-icon-font", "A");
                        subcat_lis[j].querySelector(".subcatname").className += " isChecked";
                    }
                }
            }
        }
    } else {
        var subcat_lis = document.querySelectorAll('.' + subcat)[0].getElementsByTagName("li");
        for(var j=0;j<subcat_lis.length;j++){
            subcat_lis[j].className = subcat_lis[j].className.replace(/\applied\b/, "");
            
            [].forEach.call(subcat_lis[j].querySelectorAll("span"), function(el){
                el.className = el.className.replace(/\isChecked\b/, "");
                if(el.classList.contains('icon')){
                    el.setAttribute("data-icon-font", "z");
                }  
            })
        }
    }
    if (cat_popup == "gender_popup") {
        _selectedvalgender = catvalArr
    } else if (cat_popup == "religion_popup") {
        _selectedvalreligion = catvalArr
    } else if (cat_popup == "origin_popup") {
        _selectedvalorigin = catvalArr
    } else if (cat_popup == "rashi_popup") {
        _selectedvalrashi = _onlyRashiNameArray
    }
}

export function loadSliders() {
    let slider = document.querySelectorAll(".article_slider");
    for (let i = 0; i < slider.length; i++) {
        let margin = 20;
        let extraWidth = 30;
        let cnt = slider[i].getAttribute("data-count");
        
        if (slider[i].getElementsByClassName('article_slide')[0]) {
            let sliderulwidth = cnt * slider[i].getElementsByClassName('article_slide')[0].offsetWidth;
            
            let marginbetweenimages = (cnt) * margin;
            slider[i].style.width = (sliderulwidth + marginbetweenimages + extraWidth) + "px";
        }
        if (slider[i].offsetWidth < document.getElementsByClassName("sub-container")[0].offsetWidth) {
            if (slider[i].nextSibling) {
                slider[i].nextSibling.remove();
            }
        }
    }

    let _slider = document.querySelectorAll(".collection-list");
    for (let i = 0; i < _slider.length; i++) {
        let margin = 10;
        let extraWidth = 40;
        let cnt = _slider[i].getAttribute("data-count");
        

        if (_slider[i].getElementsByClassName('dev_selcoll')[0]) {
            let sliderulwidth = cnt * _slider[i].getElementsByClassName('dev_selcoll')[0].offsetWidth;
            
            let marginbetweenimages = (cnt) * margin;
            _slider[i].style.width = (sliderulwidth + marginbetweenimages + extraWidth) + "px";
            
        }
        if (_slider[i].offsetWidth < document.getElementsByClassName("sub-container")[0].offsetWidth) {
            if (_slider[i].nextSibling) {
                _slider[i].nextSibling.remove();
            }
        }
    }
}

export function loadCollectionSlider(){
    let slider = document.querySelectorAll(".collection-list");
    for (let i = 0; i < slider.length; i++) {
        let margin = 20;
        let extraWidth = 30;
        let cnt = slider[i].getAttribute("data-count");
        
        if (slider[i].getElementsByClassName('dev_selcoll')[0]) {
            let sliderulwidth = cnt * slider[i].getElementsByClassName('dev_selcoll')[0].offsetWidth;
            
            let marginbetweenimages = (cnt) * margin;
            slider[i].style.width = (sliderulwidth + marginbetweenimages + extraWidth) + "px";
        }
        if (slider[i].offsetWidth < document.getElementsByClassName("sub-container")[0].offsetWidth) {
            if (slider[i].nextSibling) {
                slider[i].nextSibling.remove();
            }
        }
    }
}

export function selectGender() {
    document.getElementsByClassName('gender_popup_overlay')[0].style.display = 'block';
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
}
export function selectReligion() {
    document.getElementsByClassName('religion_popup_overlay')[0].style.display = 'block';
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
}
export function selectOrigin() {
    document.getElementsByClassName('origin_popup_overlay')[0].style.display = 'block';
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
}
export function selectRashi() {
    document.getElementsByClassName('rashi_popup_overlay')[0].style.display = 'block';
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
}

export function findnames(eleRef){
    var strurl;
    var local_base_url = "/baby-names/";
    // debugger;
    if(_selectedvalgender.length == 1 && (_selectedvalreligion.length == 1 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0) && _selectedvalstarting.length == 1){
        var _catVal = '';
        var _catName = '';
        if(_selectedvalreligion.length == 1){
            _catVal = _selectedvalreligion;
            _catName = 'religion';
        }
       
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/" + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }

    else if(_selectedvalgender.length == 1 && (_selectedvalnumerology.length == 1 && _selectedvalreligion.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0) && _selectedvalstarting.length == 1){

        var _catVal = '';
        var _catName = '';
       if(_selectedvalnumerology.length == 1){
            _catVal = _selectedvalnumerology;
            _catName = 'numerology';
        }
               
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/" + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }

    else if(_selectedvalgender.length == 1 && (_selectedvalrashi.length == 1 && _selectedvalnumerology.length == 0 && _selectedvalreligion.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0) && _selectedvalstarting.length == 1){

        var _catVal = '';
        var _catName = '';
       if(_selectedvalrashi.length == 1){
            _catVal = _selectedvalrashi;
            _catName = 'rashi';
        }
       
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/" + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }

    else if(_selectedvalgender.length == 1 && (_selectedvalnakshatra.length == 1 && _selectedvalrashi.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalreligion.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0) && _selectedvalstarting.length == 1){

        var _catVal = '';
        var _catName = '';
       if(_selectedvalnakshatra.length == 1){
            _catVal = _selectedvalnakshatra;
            _catName = 'nakshatra';
        }
        
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/" + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }
    
    else if(_selectedvalgender.length == 1 && (_selectedvalgod.length == 1 && _selectedvalnakshatra.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalreligion.length == 0 &&  _selectedvalorigin.length == 0) && _selectedvalstarting.length == 1){

        var _catVal = '';
        var _catName = '';
        if(_selectedvalgod.length == 1){
            _catVal = _selectedvalgod;
            _catName = 'god-goddesses';
        }
        
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/" + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }
    else if(_selectedvalgender.length == 1 && (_selectedvalorigin.length == 1 && _selectedvalgod.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalreligion.length == 0) && _selectedvalstarting.length == 1){

        var _catVal = '';
        var _catName = '';
       if(_selectedvalorigin.length == 1){
            _catVal = _selectedvalorigin;
            _catName = 'origin';
        }
        
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/" + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }

    else if((_selectedvalreligion.length == 1 && _selectedvalorigin.length == 0 && _selectedvalgod.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnumerology.length == 0) &&  _selectedvalstarting.length == 1 && (_selectedvalgender.length == 0)){
        var _catVal = '';
        var _catName = '';
        if(_selectedvalreligion.length == 1){
            _catVal = _selectedvalreligion;
            _catName = 'religion';
        }
        
        strurl = local_base_url + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }

    else if((_selectedvalnumerology.length == 1 && _selectedvalreligion.length == 0 && _selectedvalorigin.length == 0 && _selectedvalgod.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalrashi.length == 0) && _selectedvalstarting.length == 1 && (_selectedvalgender.length == 0)){
        var _catVal = '';
        var _catName = '';
        if(_selectedvalnumerology.length == 1){
            _catVal = _selectedvalnumerology;
            _catName = 'numerology';
        }
        
        strurl = local_base_url + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }

    else if((_selectedvalrashi.length == 1 && _selectedvalnumerology.length == 0 && _selectedvalreligion.length == 0 && _selectedvalorigin.length == 0 && _selectedvalgod.length == 0 && _selectedvalnakshatra.length == 0) && _selectedvalstarting.length == 1 && (_selectedvalgender.length == 0)){
        var _catVal = '';
        var _catName = '';
        if(_selectedvalrashi.length == 1){
            _catVal = _selectedvalrashi;
            _catName = 'rashi';
        }
        
        strurl = local_base_url + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }

    else if((_selectedvalnakshatra.length == 1 && _selectedvalnumerology.length == 0 && _selectedvalreligion.length == 0 && _selectedvalorigin.length == 0 && _selectedvalgod.length == 0 && _selectedvalrashi.length == 0) && _selectedvalstarting.length == 1 && (_selectedvalgender.length == 0)){
        var _catVal = '';
        var _catName = '';
        if(_selectedvalnakshatra.length == 1){
            _catVal = _selectedvalnakshatra;
            _catName = 'nakshatra';
        }
       
        strurl = local_base_url + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }

    else if((_selectedvalgod.length == 1 && _selectedvalnakshatra.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalreligion.length == 0 && _selectedvalorigin.length == 0 && _selectedvalrashi.length == 0) && _selectedvalstarting.length == 1 && (_selectedvalgender.length == 0)){
        var _catVal = '';
        var _catName = '';
        if(_selectedvalgod.length == 1){
            _catVal = _selectedvalgod;
            _catName = 'god-goddesses';
        }
        strurl = local_base_url + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }
    else if((_selectedvalorigin.length == 1 && _selectedvalgod.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalreligion.length == 0 && _selectedvalrashi.length == 0) && _selectedvalstarting.length == 1 && (_selectedvalgender.length == 0)){
        var _catVal = '';
        var _catName = '';
       if(_selectedvalorigin.length == 1){
            _catVal = _selectedvalorigin;
            _catName = 'origin';
        }

        strurl = local_base_url + _catName + '/' + _catVal[0].toLowerCase().replace(/ /g, "-") +'/starting-with/'+ _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") +'/';
    }

    else if (_selectedvalgender.length == 1 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/";

    } else if (_selectedvalgender.length == 0 && _selectedvalreligion.length == 1 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        strurl = local_base_url + "religion/" + _selectedvalreligion[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 0 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 1 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        strurl = local_base_url + "numerology/" + _selectedvalnumerology[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 0 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 1 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        var rashi = _selectedvalrashi[0];
        var onlyrashi = rashi.split(" ");
        strurl = local_base_url + "rashi/" + onlyrashi[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 0 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 1 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        var nakshatra = _selectedvalnakshatra[0];
        var onlynakshatra = nakshatra.split(" ");
        strurl = local_base_url + "nakshatra/" + onlynakshatra[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 0 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 1 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        strurl = local_base_url + "starting-with/" + _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 0 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 1 && _selectedvalorigin.length == 0 && !searchedname) {
        strurl = local_base_url + "god-goddesses/" + _selectedvalgod[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 0 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 1 && !searchedname) {
        strurl = local_base_url + "origin/" + _selectedvalorigin[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 1 && _selectedvalreligion.length == 1 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/religion/" + _selectedvalreligion[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 1 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 1 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/numerology/" + _selectedvalnumerology[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 1 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 1 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        var rashi = _selectedvalrashi[0];
        var onlyrashi = rashi.split(" ");
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/rashi/" + onlyrashi[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 1 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 1 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        var nakshatra = _selectedvalnakshatra[0];
        var onlynakshatra = nakshatra.split(" ");
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/nakshatra/" + onlynakshatra[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 1 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 1 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/starting-with/" + _selectedvalstarting[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 1 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 1 && _selectedvalorigin.length == 0 && !searchedname) {
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/god-goddesses/" + _selectedvalgod[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 1 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 1 && !searchedname) {
        strurl = local_base_url + _selectedvalgender[0].toLowerCase().replace(/ /g, "-") + "/origin/" + _selectedvalorigin[0].toLowerCase().replace(/ /g, "-") + "/";
    } else if (_selectedvalgender.length == 0 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0 && !searchedname) {
        var x = document.getElementById("toastMsg");
        x.className = "show";
        setTimeout(function () {
            x.className = x.className.replace("show", "");
        }, 3000);
        var lefttoast = (window.innerWidth - x.offsetWidth) / 2;
        x.style.left = lefttoast + "px";
    }
    else {

         Cookies.set('selectedvalgender', _selectedvalgender);
         Cookies.set('selectedvalreligion', _selectedvalreligion);
         Cookies.set('selectedvalnumerology', _selectedvalnumerology);
         Cookies.set('selectedvalrashi', _selectedvalrashi);
         Cookies.set('selectedvalnakshatra', _selectedvalnakshatra);
         Cookies.set('selectedvalstarting', _selectedvalstarting);
         Cookies.set('selectedvalgod', _selectedvalgod);
         Cookies.set('selectedvalorigin', _selectedvalorigin);
         Cookies.set('searchedname', searchedname);

         localStorage.setItem('selectedvalgender', _selectedvalgender);
         localStorage.setItem('selectedvalreligion', _selectedvalreligion);
         localStorage.setItem('selectedvalnumerology', _selectedvalnumerology);
         localStorage.setItem('selectedvalrashi', _selectedvalrashi);
         localStorage.setItem('selectedvalnakshatra', _selectedvalnakshatra);
         localStorage.setItem('selectedvalstarting', _selectedvalstarting);
         localStorage.setItem('selectedvalgod', _selectedvalgod);
         localStorage.setItem('selectedvalorigin', _selectedvalorigin);
         localStorage.setItem('searchedname', searchedname);
         
        strurl = local_base_url + "search/";
    }
    if (strurl) {
        service.showLoader();
        window.location.href = (service.getRedirectUrl(strurl));
        // if(eleRef.props.match.path !== "/baby-names"){
        //     setTimeout(() => {
        //         eleRef.reloadData();
        //     }, 500);
        // }
    }
}
export function morefilter(){
    localStorage.setItem('all_filters', true);
    Cookies.set('all_filters', true);
    showSubCat('gender');
    document.getElementsByClassName('filter-overlay')[0].style.display = 'block';
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';

    if(Cookies.get('all_filters') == "true"){
        [].forEach.call(document.querySelectorAll(".subcategorieslist"), function(ele){
            checkedparent = ele.classList;
            subcat_count = document.querySelector("." + checkedparent[0]).querySelectorAll(".subcatname.isChecked").length;

            if (subcat_count > 0) {
                document.getElementById(checkedparent[0].split("sub")[1]).querySelector(".subcatCount").innerHTML = (subcat_count + " Selected");
            }
            else {
                document.getElementById(checkedparent[0].split("sub")[1]).querySelector(".subcatCount").innerHTML = '';
            }
        });
    }
}
export function domClick(event) {
    if (!event.target.classList.contains('abuse_icon')) {
        let ary = document.getElementsByClassName('abuse-tooltip');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
    }
    
    if (!event.target.classList.contains('share-icon') && !event.target.classList.contains('share-text') && !event.target.classList.contains('share-container') && !event.target.classList.contains("shareIcon") && !event.target.classList.contains("M14_9e") && !event.target.classList.contains("whatsappIcon") && !event.target.classList.contains("fbimg")) {
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'none';
        }
        document.getElementsByTagName("body")[0].style.overflow = "auto";
    }

    if(!event.target.classList.contains('editDeleteIcon')){
        [].forEach.call(document.querySelectorAll(".editOptions"), function(ele){
            ele.style.display = "none";
        })
    }
    if(event.target.classList.contains("collection-list-popup") && !event.target.classList.contains("collection") && !event.target.classList.contains("next") && !event.target.classList.contains("prev") ){
       
        document.querySelector(".collection-list-popup").style.display = "none";
        document.getElementsByTagName("body")[0].style.overflow = "auto";
        [].forEach.call(document.querySelectorAll(".openpopup"), function(elem){
            
            elem.className = elem.className.replace(/\openpopup\b/, "");
        })
    }
    if(!event.target.classList.contains("sort-ic") && !event.target.classList.contains("sort_filter_text") && !event.target.classList.contains("sort_cont") && !event.target.classList.contains("sort-menu")){
        if(document.querySelector(".sort-list-popup")) {
            document.querySelector(".sort-list-popup").style.display = "none";
        }
    }
}
export function applyfilter(event, eleRef){
    document.getElementsByTagName('body')[0].style.overflow = 'unset';
    applyFilteronCat(event, "gender_popup", _selectedvalgender, "gender_filter", "subgender", "Gender");
    applyFilteronCat(event, "religion_popup", _selectedvalreligion, "religion_filter", "subreligion", "Religion");
    applyFilteronCat(event, "origin_popup",  _selectedvalorigin, "origin_filter", "suborigin", "Origin");
    applyFilteronCat(event, "rashi_popup", _selectedvalrashi, "rashi_filter", "subrashi", "Rashi");
    applyFilteronCat(event, "", _selectedvalstarting, "", "substartwith", "");
    applyFilteronCat(event, "", _selectedvalgod, "", "subgod", "");
    applyFilteronCat(event, "", _selectedvalnumerology, "", "subnumerology", "");
    applyFilteronCat(event, "", _selectedvalnakshatra, "", "subnakshatra", "");

     Cookies.set('selectedvalgender', _selectedvalgender);
     Cookies.set('selectedvalreligion', _selectedvalreligion);
     Cookies.set('selectedvalnumerology', _selectedvalnumerology);
     Cookies.set('selectedvalrashi', _selectedvalrashi);
     Cookies.set('selectedvalnakshatra', _selectedvalnakshatra);
     Cookies.set('selectedvalstarting', _selectedvalstarting);
     Cookies.set('selectedvalgod', _selectedvalgod);
     Cookies.set('selectedvalorigin', _selectedvalorigin);

    localStorage.setItem('selectedvalgender', _selectedvalgender);
    localStorage.setItem('selectedvalreligion', _selectedvalreligion);
    localStorage.setItem('selectedvalnumerology', _selectedvalnumerology);
    localStorage.setItem('selectedvalrashi', _selectedvalrashi);
    localStorage.setItem('selectedvalnakshatra', _selectedvalnakshatra);
    localStorage.setItem('selectedvalstarting', _selectedvalstarting);
    localStorage.setItem('selectedvalgod', _selectedvalgod);
    localStorage.setItem('selectedvalorigin', _selectedvalorigin);


    if (_selectedvalgender.length == 0 && _selectedvalreligion.length == 0 && _selectedvalnumerology.length == 0 && _selectedvalrashi.length == 0 && _selectedvalnakshatra.length == 0 && _selectedvalstarting.length == 0 && _selectedvalgod.length == 0 && _selectedvalorigin.length == 0) {
        var x = document.getElementById("toastMsg");
        x.className = "show";
        setTimeout(function () {
            x.className = x.className.replace("show", "");
        }, 3000);
        var lefttoast = (window.innerWidth - x.offsetWidth) / 2;
        x.style.left = lefttoast + "px";
        
    } else {
        document.getElementsByClassName('filter-overlay')[0].style.display = 'none';
        findnames(eleRef);
    }

    localStorage.setItem('all_filters', false);
    Cookies.set('all_filters', false);

    document.getElementById("sabcat_search").value = '';
}

function applyFilteronCat(event, cat_popup, catvalArr, catFilter, subcat, catname) {
   
        [].forEach.call(document.querySelectorAll("." + subcat), function(el){
            var isChecked = el.querySelectorAll(".R14_42.isChecked");
            if(isChecked.length > 0){
                catvalArr = [];
                for(var i = 0; i < isChecked.length;i++){
                    isChecked[i].parentElement.className = isChecked[i].parentElement.className.replace(/\applied\b/, "");
                    isChecked[i].previousSibling.setAttribute("data-icon-font", "z");
                    isChecked[i].parentElement.classList += " applied";

                    if(subcat == "subnakshatra" || subcat == "subrashi"){
                        var onlycatg = isChecked[i];
                    
                        var onlysecond = onlycatg.innerHTML.split(" ")[0];
                        
                        catvalArr.push(onlysecond);
                        
                    }else {
                        var onlycatg = isChecked[i];

                        var onlysecond = onlycatg.innerHTML;
                        
                        catvalArr.push(onlysecond);
                    }
                }
                
            } else {
                catvalArr = [];
                [].forEach.call(el.querySelectorAll("li"), function(elem){
                    elem.className = elem.className.replace(/\applied\b/, "");
                    [].forEach.call(elem.querySelectorAll(".icon"), function(element){
                        element.setAttribute("data-icon-font", "z");
                    });
                })
            }
        })
    // }
    if (cat_popup == "gender_popup") {
        _selectedvalgender = catvalArr
    } else if (cat_popup == "religion_popup") {
        _selectedvalreligion = catvalArr
    } else if (cat_popup == "origin_popup") {
        _selectedvalorigin = catvalArr
    } else if (cat_popup == "rashi_popup") {
        _selectedvalrashi = catvalArr
    } else if (subcat == "substartwith") {
        _selectedvalstarting = catvalArr
    } else if (subcat == "subgod") {
        _selectedvalgod = catvalArr
    } else if (subcat == "subnumerology") {
        _selectedvalnumerology = catvalArr
    } else if (subcat == "subnakshatra") {
        _selectedvalnakshatra = catvalArr
    }
}

export function showSubCat(category) {
    var allList = document.querySelector(".categorieslist").children;
    for(var i=0;i < allList.length; i++){
        allList[i].classList.remove("active");
    }        
    document.getElementsByClassName(category)[0].classList += " active";
    var subLists = document.querySelector(".subcategory_list").children;
    
    for(var j=0; j < subLists.length; j++){
        subLists[j].classList.remove("active");
    }
    document.querySelector(".sub" + category).classList += " active";  
}
export function loadData(){
   
    var disc_comment = document.querySelectorAll(".discussion-readless");
    
    

    [].forEach.call(disc_comment, function(el){
        if(el.offsetHeight >= 40){
            el.style.overflow = "hidden";
            el.style.height = "40px";
            el.querySelector(".baby_name_finder_text").style.display = '-webkit-box';
            el.nextSibling.style.display = "block";
        } else {
            el.style.overflow = "unset";
            el.style.height = "auto";

            el.querySelector(".baby_name_finder_text").style.display = 'block';
            el.nextSibling.style.display = "none";
        }
    });

    if(window.innerWidth < 767){
        document.querySelector(".filter-overlay").style.padding = (window.innerHeight - 500) + "px 0 0 0";
    }
}

export function readmoreClick(event, parentClass, mainClass, height) {
    event.preventDefault();
    if (event.target.innerHTML == "Read More") {
        event.target.innerHTML = "Read Less";
        
        var previous = event.target.parentElement.previousSibling;
        
        previous.style.overflow = "auto";
        previous.style.height = "auto";
        previous.style.maxHeight = "none";
        previous.querySelector("span").style.display = "block";

    } else {
        event.target.innerHTML = "Read More";
        var previous = event.target.parentElement.previousSibling;

        previous.style.overflow = "hidden";
        previous.style.height = "40px";
        previous.style.maxHeight = height;
        previous.querySelector("span").style.display = '-webkit-box';
    }
}

export function tofavNameCollection(el){
    if (global.ftk !== '') {
        var pageUrl = window.location.pathname.split('/baby-names');
        
        if (pageUrl[1] == undefined) {
            localStorage.setItem("backTothispage", local_base_url);
        } else {
            
            localStorage.setItem("backTothispage", "/baby-names" + pageUrl[1]);
        }
        el.props.history.push(service.getRedirectUrl("/baby-names/favorite-baby-names/"));
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    }
}
   
export function toListingPage(categoryname, gender, religion, category) {
    
    if (category == 'God') {
        var genderArray = ["Girl", "Boy", "Unisex"];
        var Religion = ["Hindu"];
        var category = ["God"];

         Cookies.set("selectedvalgender", genderArray);
         Cookies.set("selectedvalreligion", Religion);
         Cookies.set("selectvalcategory", category);

         var urltoRedirect = "/baby-names/god-goddesses/amp/";
    }else{
        var genderArray = [];
        if(gender.includes(",")){
            Cookies.set("selectedvalgender", []);
            Cookies.set("selectedvalreligion", ["Hindu"]);

            var urltoRedirect = "/baby-names/religion/"+religion.toLowerCase() + "/amp/";

        } else {
            genderArray.push(gender.toLowerCase());
            var Religion = [];
            var Origin = [];
            if(religion !== ""){
                Religion.push(religion.toLowerCase());
                Origin.push("all");
            } else {
                Religion.push("all");
                Origin.push("indian");
            }

            Cookies.set("selectedvalgender", genderArray);
            Cookies.set("selectedvalreligion", Religion);
            Cookies.set("selectedvalorigin", Origin);

            if(religion !== ""){
                var urltoRedirect = "/baby-names/" + gender.toLowerCase()+"/religion/"+religion.toLowerCase()+"/amp/";
            } else {
                var urltoRedirect = "/baby-names/" + gender.toLowerCase()+"/origin/indian/amp/";
            }
        }
    }
    return urltoRedirect;
}

export function showSort(){
    document.querySelector('.sort-list-popup').style.display = "block";
    [].forEach.call(document.querySelector(".sort-menu").querySelectorAll("li"), function(ele){
        if(window.location.href.indexOf("?sort=") != -1){
            if(window.location.href.split("?sort=")[1].replace(/%20/g, " ") == ele.innerHTML){
                ele.classList += " active";
            }
        }
    })
}
export function sortby(event, ele){
    [].forEach.call(document.querySelector(".sort-menu").querySelectorAll("li"), function(el) {
       if(el.classList.contains("active")){
            el.className = el.className.replace(/\active\b/, "");
       }
    });
    event.preventDefault();
    event.target.classList += " active";
    var sortval = "?sort=" + event.target.innerHTML;
    if (window.location.pathname.indexOf("page") != -1) {
        var urlwithoutpage = window.location.pathname.split("/");
        urlwithoutpage.pop();
        urlwithoutpage.pop();
        var newUrl = urlwithoutpage.join("/");
        
        var sorturl = newUrl + "/" + sortval;
        
    } else if (window.location.href.indexOf("?sort") != -1) {
        var urlwithoutparam = window.location.pathname.split("?");
        var sorturl = urlwithoutparam[0] + sortval;
    } else {
        var sorturl = window.location.pathname + sortval;
    }


    if(global.ftk === '' && event.target.innerHTML == "Not in my collection"){
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        
    } else {

        window.location.href = service.getRedirectUrl(sorturl);
        // ele.props.history.push(service.getRedirectUrl(sorturl));
    }
}
export function showFilter() {
    localStorage.setItem("all_filters", true);

    Cookies.set('all_filters', true);
    showSubCat('gender');
    document.getElementsByClassName('filter-overlay')[0].style.display = 'block';
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    document.querySelector('.filter-popup').style.display = 'block';

    var discussion_page = window.location.pathname.split('/');
    var _value_2 = discussion_page[2];
    _value_2 = _value_2 ? _value_2 : "";                     
    (_value_2 && _value_2.includes('?')) ? (_value_2 = _value_2.split('?')[0]) : (_value_2 = _value_2);

    var _value_3 = discussion_page[3];
    _value_3 = _value_3 ? _value_3 : "";
    (_value_3 &&_value_3.includes('?')) ? (_value_3 = _value_3.split('?')[0]) : (_value_3 = _value_3);

    var _value_4 = discussion_page[4];
    _value_4 = _value_4 ? _value_4 : "";
    (_value_4 && _value_4.includes('?')) ? (_value_4 = _value_4.split('?')[0]) : (_value_4 = _value_4);

    var _value_5 = discussion_page[5];
    _value_5 = _value_5 ? _value_5 : "";
    (_value_5 && _value_5.includes('?')) ? (_value_5 = _value_5.split('?')[0]) : (_value_5 = _value_5);

    var _value_6 = discussion_page[6];
    _value_6 = _value_6 ? _value_6 : "";
    (_value_6 && _value_6.includes('?')) ? (_value_6 = _value_6.split('?')[0]) : (_value_6 = _value_6);
    
    if (_value_2 == "search") {
        if(localStorage.getItem('selectedvalreligion')){
            var relg = localStorage.getItem('selectedvalreligion').split(",");
            
            filterToCategory("subreligion", relg)
        }
        else {
            
            var relg = "";
        }

        if(localStorage.getItem('selectedvalgender')){
            var gen = localStorage.getItem('selectedvalgender').split(",");
            filterToCategory("subgender", gen)
        } else {
            var gen = "";
        }
        
        if(localStorage.getItem('selectedvalnumerology')){

            
            var nume = localStorage.getItem('selectedvalnumerology').split(",");
            filterToCategory("subnumerology", nume)
        } else {
            
            var nume = "";
        }
        
        if(localStorage.getItem('selectedvalrashi')){
            var rashi = localStorage.getItem('selectedvalrashi').split(",");
            filterToCategory("subrashi", rashi)
        } else {
            var rashi = "";
        }
       
        if(localStorage.getItem('selectedvalstarting')){
            
            var startWith = localStorage.getItem('selectedvalstarting').split(",");
           
            filterToCategory("substartwith", startWith)
        } else {
            var startWith = "";
        }
        
        if(localStorage.getItem('selectedvalnakshatra')){

            var nakshatra = localStorage.getItem('selectedvalnakshatra').split(",");
            filterToCategory("subnakshatra", nakshatra)
        } else {

            var nakshatra = "";
        }

        if(localStorage.getItem('selectedvalgod')){
            
            var god = localStorage.getItem('selectedvalgod').split(",");
            filterToCategory("subgod", god)
        } else {
            var god = "";
        }

        if(localStorage.getItem('selectedvalorigin')){
            var origin = localStorage.getItem('selectedvalorigin').split(",");
            filterToCategory("suborigin", origin)
        } else {
            var origin = "";
        }
    }
    if (_value_2 == "starting-with" || _value_3 == "starting-with") {
        var startWith = localStorage.getItem('selectedvalstarting').split(",");
        
        if (startWith != "") {
            filterToCategory("substartwith", startWith)
        }
    }
    
    if (_value_2 == "nakshatra" || _value_3 == "nakshatra") {
        var nakshatra = localStorage.getItem('selectedvalnakshatra').split(",");
        
        if (nakshatra != "") {
            filterToCategory("subnakshatra", nakshatra)
        }
    }
    if (_value_2 == "god-goddesses" || _value_3 == "god-goddesses") {
        if (_value_3) {
            var god = localStorage.getItem('selectedvalgod').split(",");
            if (god != "") {
                filterToCategory("subgod", god)
            }
        }
        var relg = localStorage.getItem('selectedvalreligion').split(",");
        if (relg != "") {
            filterToCategory("subreligion", relg)
        }
        var gen = localStorage.getItem('selectedvalgender').split(",");
        if (gen != "") {
            filterToCategory("subgender", gen)
        }
    }
    if (_value_2 == "origin" || _value_3 == "origin") {
        var origin = localStorage.getItem('selectedvalorigin').split(",");
        if (origin != "") {
            filterToCategory("suborigin", origin)
        }
        var gen = localStorage.getItem('selectedvalgender').split(",");
        if (gen != "") {
            filterToCategory("subgender", gen)
        }
    }
    if (_value_2 == "religion" || _value_3 == "religion") {
        var relg = localStorage.getItem('selectedvalreligion').split(",");
        if (relg != "") {
            filterToCategory("subreligion", relg)
        }
        var gen = localStorage.getItem('selectedvalgender').split(",");
        if (gen != "") {
            filterToCategory("subgender", gen)
        }
    }
    if (_value_2 == "numerology" || _value_3 == "numerology") {
        var numerology = localStorage.getItem('selectedvalnumerology').split(",");
        
        if (numerology != "") {
            filterToCategory("subnumerology", numerology)
        }
        var gen = localStorage.getItem('selectedvalgender').split(",");
       
        if (gen != "") {
            filterToCategory("subgender", gen)
        }
    }
    if (_value_2 == "rashi" || _value_3 == "rashi") {
        var rashi = localStorage.getItem('selectedvalrashi');
        var _rashiArray = [];
        -_rashiArray.push(rashi);
        // if(_rashiArray.length == 2){
            if (_rashiArray != "") {
                filterToCategory("subrashi", _rashiArray)
            }
            var gen = localStorage.getItem('selectedvalgender').split(",");
            if (gen != "") {
                filterToCategory("subgender", gen)
            }
        // }
    }
    if (_value_2 == "boy" || _value_2 == "unisex" || _value_2 == "girl") {
        var gender = localStorage.getItem('selectedvalgender').split(",");
        if (gender != "") {
            filterToCategory("subgender", gender)
        }
    }
    
    if(_value_4 == 'starting-with'){
        var startWith = localStorage.getItem('selectedvalstarting').split(",");
        if (startWith != "") {
            filterToCategory("substartwith", startWith)
        }

        if (_value_2 == "nakshatra") {
            var nakshatra = localStorage.getItem('selectedvalnakshatra').split(",");
            if (nakshatra != "") {
                filterToCategory("subnakshatra", nakshatra)
            }
        }
        if (_value_2 == "god-goddesses") {
            var god = localStorage.getItem('selectedvalgod').split(",");
            if (god != "") {
                filterToCategory("subgod", god)
            }
        }
        if (_value_2 == "origin") {
            var origin = localStorage.getItem('selectedvalorigin').split(",");
            
            if (origin != "") {
                filterToCategory("suborigin", origin)
            }
        }
        if (_value_2 == "religion") {
            var relg = localStorage.getItem('selectedvalreligion').split(",");
            if (relg != "") {
                filterToCategory("subreligion", relg)
            }
            
        }
        if (_value_2 == "numerology") {
            var numerology = localStorage.getItem('selectedvalnumerology').split(",");
            if (numerology != "") {
                filterToCategory("subnumerology", numerology)
            }
        }
        if (_value_2 == "rashi") {
            var rashi = localStorage.getItem('selectedvalrashi').split(",");
            if (_rashiArray != "") {
                filterToCategory("subrashi", _rashiArray)
            }
        }
    }
    if(_value_5 == 'starting-with'){
        
        var gender = localStorage.getItem('selectedvalgender').split(",");
        if (gender != "") {
            filterToCategory("subgender", gender)
        }
        var startWith = localStorage.getItem('selectedvalstarting').split(",");
        if (startWith != "") {
            filterToCategory("substartwith", startWith)
        }
        if (_value_3 == "nakshatra") {
            var nakshatra = localStorage.getItem('selectedvalnakshatra').split(",");
            if (nakshatra != "") {
                filterToCategory("subnakshatra", nakshatra)
            }
        }
        if (_value_3 == "god-goddesses") {
            var god = localStorage.getItem('selectedvalgod').split(",");
            if (god != "") {
                filterToCategory("subgod", god)
            }
        }
        if (_value_3 == "origin") {
            var origin = localStorage.getItem('selectedvalorigin').split(",");
            if (origin != "") {
                filterToCategory("suborigin", origin)
            }
        }
        if (_value_3 == "religion") {
            var relg = localStorage.getItem('selectedvalreligion').split(",");
            if (relg != "") {
                filterToCategory("subreligion", relg)
            }
            
        }
        if (_value_3 == "numerology") {
            var numerology = localStorage.getItem('selectedvalnumerology').split(",");
            if (numerology != "") {
                filterToCategory("subnumerology", numerology)
            }
            
        }
        if (_value_3 == "rashi") {
            var rashi = localStorage.getItem('selectedvalrashi').split(",");
            if (rashi != "") {
                filterToCategory("subrashi", _rashiArray)
            }
        }
    }
    if(Cookies.get('all_filters') == "true"){
        [].forEach.call(document.querySelectorAll(".subcategorieslist"), function(ele){
            checkedparent = ele.classList;
            subcat_count = document.querySelector("." + checkedparent[0]).querySelectorAll(".subcatname.isChecked").length;

            if (subcat_count > 0) {
                document.getElementById(checkedparent[0].split("sub")[1]).querySelector(".subcatCount").innerHTML = (subcat_count + " Selected");
            }
            else {
                document.getElementById(checkedparent[0].split("sub")[1]).querySelector(".subcatCount").innerHTML = '';
            }
        });
    }
}

export function shareOn(e) {
    if (global.ftk === '') {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    } else {
        document.querySelector('.sharing-options').style.display = "block";
        if (window.innerWidth < 767) {
            document.querySelector('.share-overlay').style.display = "block";
            
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        }
    }
}

export function shareList(e, shareoption) {
    document.querySelector('.sharing-options').style.display= 'none';
    var urlpath = window.location.href;

    var collectionId = window.location.pathname.split('/')[3];
    // if (collectionId) {
    //     var articleurl = window.location.href;
    // } else {
        var articleurl = window.location.href;
    // }
    document.getElementsByTagName('body')[0].style.overflow = 'unset';
    var shareurl;
    if (shareoption == "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption == "google") {
        shareurl = 'https://plus.google.com/share?url=';
    } else if (shareoption == "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption == "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption == "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }

    document.querySelector('.share-overlay').style.display = "none";
    
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}  

export function closeLikedUserPopup(event) {
    event.preventDefault();
    if(event.target.getAttribute("id") == "favouriteNames") {
        document.querySelector(".favNames_overlay").style.display = "block";
    } else if (event.target.getAttribute("id") == "usersLikedcomments") {
        document.querySelector(".comments_overlay").style.display = "block";
    } else if (event.target.getAttribute("id") == "usersLikedreplies") {
        document.querySelector(".replies_overlay").style.display = "block";
    }
    document.querySelector(".likes-overlay").style.display = "none";
    document.getElementsByTagName('body')[0].style.overflow = "auto";
}

export function tonamedetails(event,recordId, babyname) {
    var urlpath = window.location.href;
    var queryparamarray = urlpath.split("/");
    var queryparam = queryparamarray[4];

    var urlsrt = window.location.href;

    var discussion_page = window.location.pathname.split('/');

    if(document.getElementById("myInputdesk")){
        document.getElementById("myInputdesk").value = '';
    }

    if(!Cookies.get("babynamemeaning")){
        babynameId_array.push(babyname + "-" + recordId);
        Cookies.set("babynamemeaning", babynameId_array);

        localStorage.setItem("babynamemeaning", babynameId_array);
    } else {
        var tempArra = [];

        tempArra.push(Cookies.get("babynamemeaning").replace(/%2C/g, ",").replace(/"/g, '').slice(1,-1).split(",")[0]);
        tempArra.push(babyname + "-" + recordId);
        localStorage.setItem("babynamemeaning", tempArra);
        Cookies.set("babynamemeaning", tempArra);
    }
}
export function showFavNames(collID, namesCount, ele) {
    localStorage.setItem("totalnamescnt", namesCount);

    window.location.href = service.getRedirectUrl(local_base_url + "favorite-baby-names/" + collID + "/");
}

export function showEdits(collId) {

    [].forEach.call(document.querySelectorAll(".editOptions"), function(ele){
        ele.style.display = "none";
    })
    
    document.getElementById("edit_" + collId).style.display = "block";
}

export function editCollection(event, collID) {
    document.querySelector(".update-overlay").style.display = "block";
    document.getElementsByTagName('body')[0].style.overflow = "hidden";
    document.querySelector(".collname_edit").value = event.target.getAttribute("data-name");
    document.querySelector(".collname_edit").setAttribute("data-id", collID);
}

export function close_filter(event){
    event.preventDefault();
    document.getElementsByTagName('body')[0].style.overflow = 'unset';
    var el = event.target.parentElement;
    
    while(el.className.split(" ")[1] != 'overlay'){
        el = el.parentElement;
    }

    if(localStorage.getItem('all_filters') !== "true"){
        var inputs = el.getElementsByClassName('filter_popups')[0].getElementsByTagName('li');
        for (var i = 0; i < inputs.length; i++) {
            if(inputs[i].classList == "applied"){
                inputs[i].querySelector('.check').classList += " isChecked";
                inputs[i].querySelector('.genName').classList += " isChecked";

                inputs[i].getElementsByClassName('check')[0].setAttribute("data-icon-font", "A");
                var appliedValue = inputs[i].getElementsByClassName("genName")[0].innerHTML;
                _appliedDataOnly.push(appliedValue);
            } else {
                var elems = document.querySelectorAll(".isChecked");
                [].forEach.call(elems, function(el) {
                    el.className = el.className.replace(/\isChecked\b/, "");
                });
                inputs[i].getElementsByClassName('check')[0].setAttribute("data-icon-font", "z");
            }
        }
    }
    
    localStorage.setItem('all_filters', false);

    Cookies.set('all_filters', false);
    el.style.display = 'none';
}
export function cancelFilter(e){

}

export function openDelete_popup(collId){
    document.querySelector(".delete-overlay").style.display = "block";
    document.getElementsByTagName('body')[0].style.overflow = "hidden";
    document.querySelector(".delete-overlay").querySelector(".M14_pink").setAttribute("data-id", collId);
}

export function checkGender(gender){
    if(gender == "Boy") {
        return (<span className="icon left boy_icon" data-icon-font="&#xe022;"></span>)
    } else if(gender == "Girl"){ 
        return (<span className="icon left girl_icon" data-icon-font="&#xe01f;"></span>)
    }else{
        return (<span className="icon left unisex_icon" data-icon-font="&#xe029;"></span>)
    }
}

export function cancelCreate_popup(event){
    event.stopPropagation();
    document.querySelector('.collection-list-popup').style.display = "none";
    document.querySelector(".new-collection").style.display = "none";
    document.querySelector(".input-name").value = '';
    document.getElementsByTagName('body')[0].style.overflow = "auto";

    document.querySelector(".error_msg").style.display = "none";
    [].forEach.call(document.querySelectorAll(".openpopup"), function(elem){
        elem.className = elem.className.replace(/\openpopup\b/, "");
    })
}

export function loadImages() {
    var imgDefer = document.getElementsByTagName('img');
    for (var i = 0; i < imgDefer.length; i++) {
        if (imgDefer[i].hasAttribute('data-src')) {
            imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('data-src'));
            imgDefer[i].removeAttribute("data-src");
        }
    }
}

export function capitalize (s){
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export function filterToCategory(subCategory, categoryCookie) {
    [].forEach.call(document.querySelector(".baby-names-list").querySelector(".filter-overlay").querySelector("." + subCategory).querySelectorAll(".subcatname"), function(value, key){
        
        if (categoryCookie.length > 1) {

            [].forEach.call(categoryCookie, function(result, index){
                if (subCategory == "subrashi") {
                    var _rashi = value.innerHTML.split(" ");
                    var onlyrashi = _rashi[0];
                    if (onlyrashi.toLowerCase() == result.toLowerCase()) {
                        if(!value.classList.contains("isChecked")){
                            value.classList += " isChecked";
                        }
                        if(!value.previousSibling.classList.contains("isChecked")){
                            value.previousSibling.classList += " isChecked";
                        }
                        
                        value.previousSibling.setAttribute("data-icon-font", "A");

                        if(!value.parentElement.classList.contains("applied")) {
                            value.parentElement.classList += " applied";
                        };
                    }
                } else if (subCategory == "subnakshatra") {
                    var _nakshatra = value.innerHTML.split(" ");
                    var onlynakshatra = _nakshatra[0];
                    if (onlynakshatra.toLowerCase() == result.toLowerCase()) {
                        if(!value.classList.contains("isChecked")){
                            value.classList += " isChecked";
                        }
                        if(!value.previousSibling.classList.contains("isChecked")){
                            value.previousSibling.classList += " isChecked";
                        }
                        value.previousSibling.setAttribute("data-icon-font", "A");
                        if(!value.parentElement.classList.contains("applied")) {
                            value.parentElement.classList += " applied";
                        };
                    }
                } else {
                    if (value.innerHTML.toLowerCase() === result.toLowerCase()) {
                        if(!value.classList.contains("isChecked")){
                            value.classList += " isChecked";
                        }
                        if(!value.previousSibling.classList.contains("isChecked")){
                            value.previousSibling.classList += " isChecked";
                        }
                        value.previousSibling.setAttribute("data-icon-font", "A");
                        if(!value.parentElement.classList.contains("applied")) {
                            value.parentElement.classList += " applied";
                        };
                    }
                }
            })
        }
        else {
            
            if (subCategory == "subrashi") {
                var _rashi = value.innerHTML.split(" ");
                var onlyrashi = _rashi[0];
                var _rashicookie = categoryCookie[0].split(" ");
                var onlycookierashi = _rashicookie[0];
                if (onlyrashi.toLowerCase() == onlycookierashi.toLowerCase()) {
                    if(!value.classList.contains("isChecked")){
                        value.classList += " isChecked";
                    }
                    if(!value.parentElement.classList.contains("isChecked")){
                        value.parentElement.classList += " isChecked";
                    }

                    
                    value.parentElement.querySelector(".icon").setAttribute("data-icon-font", "A");
                    if(!value.parentElement.querySelector(".icon").classList.contains("isChecked")){
                        value.parentElement.querySelector(".icon").classList += " isChecked";
                    }
                    
                    if(!value.parentElement.classList.contains("applied")) {
                        value.parentElement.classList += " applied";
                    };
                }
            } else if (subCategory == "subnakshatra") {
                var _nakshatra = value.innerHTML.split(" ");
                var onlynakshatra = _nakshatra[0];
                var _nakshatracookie = categoryCookie[0].split(" ");
                var onlycookienakshatra = _nakshatracookie[0];

                if (onlynakshatra.toLowerCase() == onlycookienakshatra.toLowerCase()) {
                    if(!value.classList.contains("isChecked")){
                        value.classList += " isChecked";
                    }
                    if(!value.parentElement.classList.contains("isChecked")){
                        value.parentElement.classList += " isChecked";
                    }
                    
                    value.parentElement.querySelector(".icon").setAttribute("data-icon-font", "A");
                    if(!value.parentElement.querySelector(".icon").classList.contains("isChecked")){
                        value.parentElement.querySelector(".icon").classList += " isChecked";
                    }
                    
                    if(!value.parentElement.classList.contains("applied")) {
                        value.parentElement.classList += " applied";
                    };
                }
            } else {
                
                if(categoryCookie[0].includes("-")){
                    categoryCookie[0] = capitalize(categoryCookie[0].split("-")[0]) + " " + capitalize(categoryCookie[0].split("-")[1]);
                    
                } else {
                    categoryCookie[0] = categoryCookie[0];
                }

                if (value.innerHTML.toLowerCase() == categoryCookie[0].toLowerCase()) {
                    
                    if(!value.classList.contains("isChecked")){
                        value.classList += " isChecked";
                    }
                    if(!value.previousSibling.classList.contains("isChecked")){
                        value.previousSibling.classList += " isChecked";
                    }

                    value.previousSibling.setAttribute("data-icon-font", "A");
                    if(!value.parentElement.classList.contains("applied")) {
                        value.parentElement.classList += " applied";
                    };
                }
            }
        }
    })
}
var recordID;
var babynametoadd;
export function heartclick(event, recordId, nametoAdd) {
    if (navigator.onLine){

        if (global.ftk === '') {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        } else {
            document.querySelector(".collection-list").innerHTML = '';
            if(event.target.classList.contains('heartselected')){
                    event.target.setAttribute("data-icon-font", "+")
                    event.target.className = event.target.className.replace(/\heartselected\b/, "");
            } else {
                document.querySelector('.collection-part1').style.display = "block";
                document.querySelector('.new-collection').style.display = "none";
                document.querySelector('.collection-list-popup').style.display = "block";
                document.querySelector("body").style.overflow = "hidden";
                event.target.className += " openpopup";
    
                var favouriteId = "";
                recordID = recordId;
                babynametoadd = nametoAdd;
            }
            var postData = {
                "pageSize": "10",
                "pageNo": 1
            }
            var url = global.api_ci_url + "Babynames/getmyfavouritelist";
            service.postServiceCall(url, postData).then((json) => {
   
                if(json['FinalResponse'] !== 'Records Not Found'){
                   this.setState({collectionListData : json['FinalResponse']});
                } else {
                   document.querySelector(".norecord-overlay").style.display = "block";
                //    document.querySelector(".collection-part1").querySelector(".list").style.display = "none";
                }
                actions.loadSliders();
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }
    } else {
        service.showAlert("Please check internet connection!!!");
    }
}

export function likeFavName(recordId, collId, collName, babyName, likeCount, event) {
    if (global.ftk === '') {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    }else{
        var action_status;
        if (event.target.classList.contains("isliked")) {
            action_status = "0";
        } else {
            action_status = "1";
        }
        var postData = {
            "recordId" : recordId,
            "collectionId" : collId,
            "collectionName" : collName,
            "babyName" : babyName,
            "postType" : "0",
            "commentId" : "",
            "action_status" : action_status,
        }
        var element = event.target;
        var url = global.api_ci_url + "Babynames/savebabylikeaction";
        service.postServiceCall(url, postData).then((json) => {
            if(json['msg'] == 1){

                
                // if (element.classList.contains("isliked")) {
                //     element.className = element.className.replace(/\isliked\b/, '');

                //     if (likeCount == 1) {
                //         var updatedlikeCount = likeCount - 1;
                //         element.nextSibling.nextSibling.innerHTML = updatedlikeCount + " Like";
                //         element.nextSibling.nextSibling.style.display = "none";
                //     } else if (likeCount > 1) {
                //         var updatedlikeCount = likeCount - 1;
                //         element.nextSibling.nextSibling.innerHTML = updatedlikeCount + " Likes";
                //     } else {
                //         element.nextSibling.nextSibling.style.display = "none";
                //     }
                // } else {
                //     element.classList += " isliked";
                //     var originalCount = element.nextSibling.nextSibling.innerHTML;
                //     if (originalCount == "0 like" || originalCount == "" || originalCount == "0 Likes" || originalCount == "0 Like") {
                //         element.nextSibling.nextSibling.innerHTML = "1 Like";
                //         element.nextSibling.nextSibling.style.display = "block";
                //     } else {
                //         var updatedlikeCount = likeCount + 1;
                //         if (updatedlikeCount == 1) {
                //             element.nextSibling.nextSibling.innerHTML = updatedlikeCount  + " Likes";
                //             element.nextSibling.nextSibling.style.display = "block";
                //         } else {
                //             element.nextSibling.nextSibling.innerHTML = updatedlikeCount + " Likes";
                //             element.nextSibling.nextSibling.style.display = "block";
                //         }
                //     }
                // }
            }
          }).catch((error) => {
              console.error(error);
          });
       
    }
}

export function showUserLikes(recordId, collId, commentId, replyId, postTypeval) {
    if (global.ftk === '') {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    }else{
        var postData = {
            "pageSize" : 100,
            "pageNo" : 1,
            "recordId" : recordId,
            "collectionId" : collId,
            "commentId" : commentId,
            "replyId" : replyId,
            "postType" : postTypeval
        }
        var url = global.api_ci_url + "Babynames/getbabynamesuserlikes";
        
        service.postServiceCall(url, postData).then((json) => {
            if(json['msg'] == 1){
                document.querySelector(".likes-wrap").querySelector("ul").innerHTML = '';
                var likedata = '';
                [].forEach.call(json['result'],  function(value, key){
                    likedata += '<li>';
                    likedata += '<div class="answers-block">';
                    likedata += '<div class="experts-details">';
                    likedata += '<span class="experts-photo">';
                    if (value.userPic == '' || value.userPic == null || value.userPic == undefined) {
                        if (value.usergender == "female") {
                            likedata += '<img class="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/mother_profile.png" /></span>'
                        } else if (value.usergender == "male") {
                            likedata += '<img class="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/father_profile.png" /></span>'
                        } else {
                            likedata += '<img class="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/default-img.png" /></span>'
                        }
                    } else {
                        likedata += '<img class="imgcheck" src="' + value.userPic + '" /></span>'
                    }
                    if (value.is_specialist) {
                        likedata += '<span class="experts-tag">Expert</span>'
                    }
                    likedata += '<span class="experts-name"><span class="exp-name M14_42">' + value.userName + '</span>';
                    likedata += '<span class="R13_9e experts-desc">' + value.userDesc + '</span></span>';
                    if (global.userAry['mycid'] != value.likeCreaterid) {

                        likedata += '<div class="follow-block R13_9e right">';
                        if (value.is_following) {
                            likedata += '<span class="likelist-follow" data-id="' + value.likeCreaterid + '" style={{display : "none"}}>Follow</span>';
                            likedata += '<span class="likelist-unfollow" data-id="' + value.likeCreaterid + '" style={{display : "inline"}}>Following</span>'
                        } else {
                            likedata += '<span class="likelist-follow" data-id="' + value.likeCreaterid + '">Follow</span>';
                            likedata += '<span class="likelist-unfollow" data-id="' + value.likeCreaterid + '" style={{display : "none"}}>Following</span>'
                        }
                        likedata += '</div>'
                    }else {
                        likedata += '';
                    }
                    likedata += '</div>';
                    likedata += '</div>';
                    likedata += '</li>'
                });
                document.querySelector(".likes-wrap").querySelector("ul").innerHTML = likedata;
                if(document.querySelector(".likelist-follow")){
                        document.querySelector(".likelist-follow").addEventListener("click", (e) => likelist_follow(e));
                        document.querySelector(".likelist-unfollow").addEventListener("click", (e) => likelist_unfollow(e));
                }

                document.querySelector(".likes-overlay").style.display = "block";

                document.getElementsByTagName('body')[0].style.overflow = "hidden";

                document.querySelector(".likes-overlay").setAttribute("id", "");

                if (commentId == " " && replyId == " ") {
                    document.querySelector(".likes-overlay .likesClose").setAttribute("id", "favouriteNames");
                } else if (commentId != " " && replyId == " ") {
                    document.querySelector(".likes-overlay .likesClose").setAttribute("id", "usersLikedcomments");
                } else if (commentId != " " && replyId != " ") {
                    document.querySelector(".likes-overlay .likesClose").setAttribute("id", "usersLikedreplies");
                }
            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });

    }
}

export function createlist() {
    document.querySelector('.new-collection').style.display = "block";
    document.querySelector('.collection-part1').style.display = "none"; 
    document.querySelector('.norecord-overlay').style.display = "none";
}
var commentIDParam;
export function openReplyPopup(recordId, commentID, collID, collName, babyname, isCreater, event) {
    document.querySelector(".addReply-overlay").style.display = "block";
    document.querySelector(".addReply-overlay").querySelector(".popup-header").querySelector(".M14_white").innerHTML = "Add a Reply";

    recordIDParam = recordId;
    commentIDParam = commentID;
    collIDParam = collID;
    collectionName = collName;
    favbabyname = babyname;
    currentElement = event.target.className;
    createdByUser = isCreater;

    var totalcmnttext = event.target.parentElement.querySelector('.replyCounts').getAttribute("data-cmnt");
    totalcmnts = Number(totalcmnttext);
    document.getElementsByTagName('body')[0].style.overflow = "hidden";
}

export function insertAfter(referenceNode, newNode) {    
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

export function showTool(event) {
    if (global.ftk === '') {
            service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    }else{
        if (event.target.classList.contains('recent_reply_abuse')) {
            event.target.parentElement.querySelector('.recent_reply_abuse-tooltip').style.display = "block";
        } else {
            if(event.target.parentElement.querySelector('.abuse-tooltip')){
                event.target.parentElement.querySelector('.abuse-tooltip').style.display = "block";
            }
        }
    }
}

export function reportAbuse(recId, collId, commnetId, replyId, event, ele) {

    var action_status;
    if (event.target.previousSibling.classList.contains("isChecked")) {
        action_status = "0";
    } else {
        action_status = "1";
    }
    if (event.target.classList.contains('active-like')) {
        event.target.off('click');
    } else {
        document.getElementsByTagName('body')[0].style.overflow = "hidden";
 
        if (replyId != " ") {
            var postType = "1";
        } else {
            var postType = "0";
        }
        
        var postData = {
            "recordId" : recId,
            "collectionId" : collId,
            "commentId" : commnetId,
            "replyId" : replyId,
            "action_status" : action_status,
            "postType" : postType
        }

        var url = global.api_ci_url + "Babynames/saveabuseaction";
        var currentEle = event.target;

        service.postServiceCall(url, postData).then((json) => {
            if(json['msg'] == 1){
                document.getElementsByTagName('body')[0].style.overflow = "auto";
                document.querySelector(".abuse-overlay").querySelector('span').innerHTML = "comment has reported for abuse and is currently under review";
                document.querySelector(".abuse-overlay").style.display = "block";
                
                setTimeout(() => {
                    document.querySelector('.abuse-overlay').style.display = "none";
                }, 1000)

                currentEle.previousSibling.classList += " isChecked";
                currentEle.previousSibling.setAttribute('title', "Reported Abuse Already");
                // currentEle.innerHTML = "Reported Abuse Already";
                // currentEle.removeEventListener("click", reportAbuse, false);
                currentEle.remove();
                // document.querySelector(".abuse-tooltip").style.display = "none";
            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
        
    }
}

var uID;
var accesstoken;
var following_array = [];
export function likelist_follow(event){
    var active_Id = event.target.getAttribute("data-id");
    
    service.showLoader();

    var uidliked = event.target.getAttribute("data-id");
    if(global.userAry['Sex']){
        var ge = global.userAry['Sex'];
    } else {
        var ge = 'NA'
    }
    var likedansFollowData = {
        "user_id": uidliked,
        "action_status": 1,
        "action_type":'follow_user',
        "userPic" : global.userAry['userPhoto'],
        "userName" : global.userAry['userName'],
        "childArr" : global.userAry['childData'],
        "userGender" : ge
    };
        var cureentclass = event.target;
        var url = global.api_ci_url + "Babynames/saveUserFollowAction";


       service.postServiceCall(url, likedansFollowData).then((json) => {
        if (json['success'] == 1) {
           service.hideLoader();
            cureentclass.style.display = "none";
            cureentclass.nextSibling.style.display = "block";
            following_array.push("'" + active_Id + "'");
            document.getElementById('following_array1').value = following_array;
        }
    })
}
export function likelist_unfollow(event){
    var removeItem = event.target.getAttribute("data-id");
    
    var uidliked = event.target.getAttribute("data-id");

    if(global.userAry['Sex']){
        var ge = global.userAry['Sex'];
    } else {
        var ge = 'NA'
    }

    var postData = {
        "user_id": uidliked,
        "action_status": 0,
        "action_type":'follow_user',
        "userPic" : global.userAry['userPhoto'],
        "userName" : global.userAry['userName'],
        "childArr" : global.userAry['childData'],
        "userGender" : ge
    };

    service.showLoader();

    var cureentclass = event.target;

    var url = global.api_ci_url + "Babynames/saveUserFollowAction";
    service.postServiceCall(url, postData).then((json) => {
        if (json['success'] == 1) {
           service.hideLoader();
            cureentclass.style.display = "none";
            cureentclass.previousSibling.style.display = "block";
            // if (following_array != null) {
            //     following_array.splice($.inArray(removeItem, following_array), 1);
            //     document.getElementById('following_array1').value = following_array;
            // }
        }
    })

}
export function toReligionNames(event, religion_names){
    var only_religion = religion_names.split(" ")[0].toLowerCase();
  
    _selectedvalreligion.push(only_religion);
    localStorage.setItem("selectedvalreligion", _selectedvalreligion);
    Cookies.set("selectedvalreligion", _selectedvalreligion);
}
 export function toOriginNames(event, origin_names){
    var only_origin = origin_names.split(" ")[0].toLowerCase();
  
    _selectedvalorigin.push(only_origin);
    localStorage.setItem("selectedvalorigin", _selectedvalorigin);
    Cookies.set("selectedvalorigin", _selectedvalorigin);
} 

export function getBabyNamesData(urlsrt){
    var _pgtitle = "";
    var _metadesc = '';
    var _keywords = '';
    let keyname = "";
    var gender = null,
    religion = null;
    var category = "",
    keyword = "";
    var startwith = null,
    origin = null,
    numerology = null,
    rashi = null,
    nakshatra = null,
    god = null;
    var sortkey = null,
    pageno = 1;
    var isSort = false;

    var _heading = '';
    var _descText = '';

    var breadcrum_1 = "";
    var breadcrum_2 = "";

    if(urlsrt.includes("?sort")){
        var _new = urlsrt.split('/');
        var discussion_page = _new;
       
        if (_new[_new.length - 1].includes("?")) {

            var windowurl = _new[_new.length - 1].split("?");
            var sortbyparam = (windowurl[1].split("&from=app")[0].split("="))[1];

            sortkey = sortbyparam.replace(/%20/g, " ");

        } else {
            sortkey = "Most Popular";
        }
        isSort = true;

    } else if(urlsrt.includes("?ref2=bnalsoreadsection")){
        var _new = urlsrt.split('/');

        var discussion_page = _new;
        discussion_page.pop();
        sortkey = "Most Popular";
    } else {
        var discussion_page = urlsrt.split('/');
        sortkey = "Most Popular";
    }

    var _value_2 = discussion_page[2];
    _value_2 = _value_2 ? _value_2 : "";                     
    (_value_2 && _value_2.includes('?')) ? (_value_2 = _value_2.split('?')[0]) : (_value_2 = _value_2);

    var _value_3 = discussion_page[3];
    _value_3 = _value_3 ? _value_3 : "";
    (_value_3 &&_value_3.includes('?')) ? (_value_3 = _value_3.split('?')[0]) : (_value_3 = _value_3);

    var _value_4 = discussion_page[4];
    _value_4 = _value_4 ? _value_4 : "";
    (_value_4 && _value_4.includes('?')) ? (_value_4 = _value_4.split('?')[0]) : (_value_4 = _value_4);

    var _value_5 = discussion_page[5];
    _value_5 = _value_5 ? _value_5 : "";
    (_value_5 && _value_5.includes('?')) ? (_value_5 = _value_5.split('?')[0]) : (_value_5 = _value_5);

    var _value_6 = discussion_page[6];
    _value_6 = _value_6 ? _value_6 : "";
    (_value_6 && _value_6.includes('?')) ? (_value_6 = _value_6.split('?')[0]) : (_value_6 = _value_6);
    
    var _value_7 = discussion_page[7];
    _value_7 = _value_7 ? _value_7 : "";
    (_value_7 && _value_7.includes('?')) ? (_value_7 = _value_7.split('?')[0]) : (_value_7 = _value_7);

    var _value_8 = discussion_page[8];
    _value_8 = _value_8 ? _value_8 : "";
    (_value_8 && _value_8.includes('?')) ? (_value_8 = _value_8.split('?')[0]) : (_value_8 = _value_8);

    if(_value_2 == "finder" && _value_3 != undefined){
            keyword = _value_3;
            
            _pgtitle = "Baby Names Finder: Search Baby Boy & Girl Names with Meanings";
            _metadesc = "Browse 100000+ baby boy and girl name ideas with FirstCry`s Baby Name Finder. Find baby names with religion, rashi, nakshatra, numerology & more";
            _heading = "Baby Names Finder";
            _keywords = "baby names, unique baby names, popular baby names";

    } else if (_value_2 == "search" && _value_3 == "amp") {

        keyname = "";
            var _genderstr = _value_2.replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });
            _heading = "Baby Names";
            _pgtitle = "Search 100+ Baby Names - FirstCry Parenting";          
            _metadesc ="Find out the most popular names for baby boy & baby girl along with meaning. Choose a perfect name for your baby from the list of 100000+ baby names.";
            _keywords = "Search Baby Names";
    }
    else if((_value_4 == "starting-with" || _value_5 == "starting-with")){
      
        if (_value_6 == "page") {
            pageno = _value_7;
        } else if(_value_7 == "page") {
            pageno = _value_8;
        } else {
            pageno = 1;
        }
        
        keyname = "";

        if(_value_4 == "starting-with"){
            var _selectedCat  = '';
            _selectedCat = _value_3.replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });
            _selectedCat = _selectedCat.replace("-", " ");

            var _selectedLetter  = '';
            _selectedLetter = _value_5.toUpperCase();

            _pgtitle = "100+ Latest & Modern " + _selectedCat +" Baby Names with Meaning Starting with " + _selectedLetter;
            _metadesc = "Looking for "+ _selectedCat +" Starting with " + _selectedLetter + " names for your baby? Check out here to get the modern, unique and latest " +_selectedCat + " baby boy & girl names Starting with " + _selectedLetter + " with meanings at FirstCry Parenting.";
            _keywords = _selectedCat + " baby names Starting with " + _selectedLetter + ", "+ _selectedCat + " baby boy names Starting with " + _selectedLetter + ", "+ _selectedCat + " baby girl names Starting with " + _selectedLetter ;
            var categoryName = _value_2.replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });
            if(categoryName == "Religion" || categoryName == "Origin"){
                _heading =  _selectedCat + " Baby Names Starting with " + _selectedLetter;
            }
            else if(categoryName == "Numerology"){
                _heading =  _selectedCat + " Numerology Number Baby Names Starting with " + _selectedLetter;
            }
            else if(categoryName == "Rashi"){
                _heading =  _selectedCat + " Rashi Baby Names Starting with " + _selectedLetter;
            }
            else if(categoryName == "Nakshatra"){
                _heading =  _selectedCat + " Nakshatra Baby Names Starting with " + _selectedLetter;
            }
            
            else if(categoryName == "God-Goddesses"){
                if(_selectedCat == "Lord Krishna" || _selectedCat == "Lord Vishnu" || _selectedCat == "Lord Shiva" ||    _selectedCat == "Lord Rama" || _selectedCat == "Lord Arjun" || _selectedCat == "Muslim" || _selectedCat == "Sikh"){
                    _heading =  "Baby Names Inspired by " + _selectedCat + " Starting with " + _selectedLetter;
                } else if(_selectedCat == "Durga"){
                    _heading =  "Baby Names Inspired by Goddess " + _selectedCat + " Starting with " + _selectedLetter;
                } else {
                    _heading =  "Baby Names Inspired by God " + _selectedCat + " Starting with " + _selectedLetter;
                }
            }
            breadcrum_1 = "Starting with";
            breadcrum_2 = _selectedLetter;

        } else {
            var _genderstr = _value_2.replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });
            
            var _selectedCat  = '';
            _selectedCat = _value_4.replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });

            _selectedCat = _selectedCat.replace("-", " ");
            
            var _selectedLetter  = '';
            _selectedLetter = _value_6.toUpperCase();
            var categoryName = _value_3.replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });

            _pgtitle = "100+ Latest & Modern " + _selectedCat +" Baby "+ _genderstr +" Names with Meaning Starting with " + _selectedLetter;
            _metadesc = "Looking for "+ _selectedCat +" baby names Starting with " + _selectedLetter + " names for your baby? Check out here to get the modern, unique and latest "+ _genderstr +" baby names by " +_selectedCat + " Starting with " + _selectedLetter + " with meanings at FirstCry Parenting.";
            _keywords = _genderstr +" Baby Names by " + _selectedCat + " Starting with " + _selectedLetter;

            if(_genderstr == "Unisex"){
                if(categoryName == "Religion" || categoryName == "Origin"){
                    _heading =  "Unisex "+_selectedCat+" Baby Names Starting with" + _selectedLetter;
                }
                else if(categoryName == "Numerology"){
                    _heading =  _selectedCat + " Numerology Number Unisex Baby Names Starting with " + _selectedLetter;
                }
                else if(categoryName == "Rashi"){
                    _heading =  _selectedCat + " Rashi Unisex Baby Names Starting with " + _selectedLetter;
                }
                else if(categoryName == "Nakshatra"){
                    _heading =  _selectedCat + " Nakshatra Unisex Baby Names Starting with " + _selectedLetter;
                }
                else if(categoryName == "God-Goddesses"){
                    // Baby Girl Names Inspired by Goddess Durga Starting with A
                    if(_selectedCat == "Lord Krishna" || _selectedCat == "Lord Vishnu" || _selectedCat == "Lord Shiva" || _selectedCat == "Lord Rama" || _selectedCat == "Lord Arjun" || _selectedCat == "Muslim" || _selectedCat == "Sikh"){
                        _heading =  "Unisex Baby Names Inspired by " + _selectedCat + " Starting with " + _selectedLetter;
                    } else if(_selectedCat == "Durga"){
                        _heading =  "Unisex Baby Names Inspired by Goddess " + _selectedCat + " Starting with " + _selectedLetter;
                    } else {
                        _heading =  "Unisex Baby Names Inspired by God " + _selectedCat + " Starting with " + _selectedLetter;
                    }
                }
            } else {
                if(categoryName == "Religion" || categoryName == "Origin"){
                    _heading =  _selectedCat + " Baby "+ _genderstr +" Names Starting with " + _selectedLetter;
                }
                else if(categoryName == "Numerology"){
                    _heading =  _selectedCat + " Numerology Number Baby "+ _genderstr +" Names Starting with " + _selectedLetter;
                }
                else if(categoryName == "Rashi"){
                    _heading =  _selectedCat + " Rashi Baby "+ _genderstr +" Names Starting with " + _selectedLetter;
                }
                else if(categoryName == "Nakshatra"){
                    _heading =  _selectedCat + " Nakshatra Baby "+ _genderstr +" Names Starting with " + _selectedLetter;
                }
                else if(categoryName == "God-Goddesses"){
                    if(_selectedCat == "Lord Krishna" || _selectedCat == "Lord Vishnu" || _selectedCat == "Lord Shiva" || _selectedCat == "Lord Rama" || _selectedCat == "Lord Arjun" || _selectedCat == "Muslim" || _selectedCat == "Sikh"){
                        _heading =  "Baby "+ _genderstr +" Names Inspired by " + _selectedCat + " Starting with " + _selectedLetter;
                    } else if(_selectedCat == "Durga"){
                        _heading = "Baby "+ _genderstr +" Names Inspired by Goddess " + _selectedCat + " Starting with " + _selectedLetter;
                    } else {
                        _heading =  "Baby "+ _genderstr +" Names Inspired by God " + _selectedCat + " Starting with " + _selectedLetter;
                    }

                }
            }
            breadcrum_1 = "Starting with";
            breadcrum_2 = _selectedLetter;
        }
        keyname = "Baby Names By religion";
        _descText = "The arrival of a newborn marks a new beginning in every parent`s life. Whether the new ones enter the parents’ lives after years of longing or as a surprise, its an atmosphere of joy and celebrations. " + _heading + " need not be old-fashioned and outdated! Check out our alphabetical list of 100+ " + _heading + " along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder.";
    }
    else if ((_value_2 == "girl" || _value_2 == "boy" || _value_2 == "unisex") && (_value_3 == 'religion' || _value_3 == 'rashi' || _value_3 == 'numerology' || _value_3 == 'origin' || _value_3 == 'nakshatra' || _value_3 == 'starting-with' || _value_3 == 'god-goddesses')) {

        Cookies.set('selectedvalgender', _value_2);
        
        var CatValue = '';
        if(_value_4 && _value_4 !== "amp"){
            if(_value_4 == "page"){
                pageno = _value_5;
            } else if(_value_5 == "page" && _value_4){
                pageno = _value_6;
                CatValue = _value_4;
            } else if(_value_3) {
                pageno = 1;
                CatValue = _value_3;
            }
        } else {
            pageno = 1;
        }
        var _selected  = '';
        
        var _genderstr = _value_2.replace(/\b[a-z]/g, function(letter) {
            return letter.toUpperCase();
        });
        
        if(CatValue == ''){
            if (_value_3 == 'religion') {
                Cookies.set("selectedvalreligion", ["all"]);
                Cookies.set("selectedvalgender", _value_2);
                religion = ["all"];
                gender = [_value_2];

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Latest & Popular "+ _genderstr +" Baby Boy Names with Meaning";
                    _metadesc = "Looking for names by Religion for your baby boy? Check out here to get the modern, unique and latest "+ _genderstr +" baby boy names with meaning at FirstCry Parenting.";
                    _keywords = "baby boy names by Religion";
                    _heading = "Baby Boy Names by Religion";
                } 
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ Cute & Modern "+ _genderstr +" Baby Girl Names with Meaning";
                    _metadesc = "Looking for names by Religion for your baby girl? Check out here to get the modern, unique and latest names by Religion for baby girl names with meaning at FirstCry Parenting." ;
                    _keywords = "baby girl names by Religion";
                    _heading = "Baby Girl Names by Religion";
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Unisex Baby Names by Religion with Meaning";
                    _metadesc = "Browse a list of 100+ most popular and trending unisex baby names based on "+ _selected +" religion with FirstCry`s baby names finder.";
                    _keywords = "unisex baby names by religion";
                    _heading = "Unisex Baby Names by Religion";
                }

            } else if (_value_3 == 'origin') {
                Cookies.set("selectedvalorigin", ["all"]);
                Cookies.set("selectedvalgender", _value_2);

                origin = ["all"];
                gender = [_value_2];

                keyname = "Baby Names by Origin";

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Latest & Popular by Origin Baby Boy Names with Meaning";
                    _metadesc = "Looking for by Origin names for your baby boy? Check out here to get the modern, unique and latest by Origin baby boy names with meaning at FirstCry Parenting.";
                    _keywords = "baby boy names by origin";
                    _heading = "Baby Boy Names by Origin";
                }
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ Cute & Modern by Origin Baby Girl Names with Meaning";
                    _metadesc = "Looking for by Origin names for your baby girl? Check out here to get the modern, unique and latest by Origin baby girl names with meaning at FirstCry Parenting.";
                    _keywords = "baby girl names by origin";
                    _heading = "Baby Girl Names by Origin";
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Popular Unisex Baby Names by Origin with Meanings";
                    _metadesc = "Browse a list of 100 + most popular and trending unisex baby names based on origin with FirstCry`s baby names finder.";
                    _keywords = "unisex names by origin";
                    _heading = "Unisex Baby Names by Origin";
                }

            } else if (_value_3 == 'numerology') {
                Cookies.set("selectedvalnumerology", ["all"]);
                Cookies.set("selectedvalgender", _value_2);
                
                numerology = ["all"];
                gender = [_value_2];

                keyname = "Baby Names By numerology Number (1-9)";
                _heading = "Baby Names by Numerology";

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Latest & Popular Baby Boy Names by Numerology";
                    _metadesc = "Looking for the lucky baby boy names by Numerology? Choose from the list of modern, unique and latest baby boy names at FirstCry Parenting.";
                    _keywords = "baby boy names by Numerology";
                    _heading = "Baby Boy Names by Numerology";
                }
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ Cute & Modern Baby Girl Names by Numerology";
                    _metadesc = "Looking for the lucky baby girl names by Numerology? Choose from the list of modern, unique and latest baby girl names at FirstCry Parenting.";
                    _keywords = "baby girl names by Numerology";
                    _heading = "Baby Girl Names by Numerology";
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Unisex Baby Names by Numerology with Meanings";
                    _metadesc = "Browse a list of 100+ most popular & trending baby names based on numerology number with FirstCry`s baby names finder.";
                    _keywords = "unisex baby names based on numerology";
                    _heading = "Unisex Baby Names by Numerology";
                }
            } else if (_value_3 == 'rashi') {

                Cookies.set("selectedvalrashi", ["all"]);
                Cookies.set("selectedvalgender", _value_2);

                rashi = ["all"];
                gender = [_value_2];
                
                keyname = "Baby Names By Hindu Rashi";
                _heading = "Baby " + _genderstr + " Names by Rashi";

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Baby Boy Names With Meaning by Rashi";
                    _metadesc = "Are you Looking for baby boy names by rashi for your little one? Here are the list of 100+ names by rashi for boys with their meaning.";
                    _keywords = "baby boy names by rashi";
                    _heading = "Baby Boy names by Rashi";
                } else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ Baby Girl Names With Meaning by Rashi";
                    _metadesc = "Are you Looking for baby girl names by rashi for your little one? Here are the list of 100+ names for girls with their meaning by rashi.";
                    _keywords = "baby girl names by rashi";
                    _heading = "Baby Girl names by Rashi";
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Unisex Names by Rashi with Meaning";
                    _metadesc = "Choose the best unisex baby names by Rashi along with their meanings with FirstCry`s baby name finder at FirstCry Parenting.";
                    _keywords = "unisex baby names by Rashi";
                    _heading = "Unisex Baby Names by Hindu Rashi";
                }
            } else if (_value_3 == 'nakshatra') {
                Cookies.set("selectedvalnakshatra", ["all"]);
                Cookies.set("selectedvalgender", _value_2);

                nakshatra = ["all"];
                gender = [_value_2];
            
                keyname = "Hindu Baby Names by Nakshatra";
                _heading = "Baby " + _genderstr + " Names by Nakshatra";

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Nakshatra Boy Names With Meaning";
                    _metadesc = "Searching for baby boy names by nakshatra? Browse the list of 100+ modern & unique baby boy names by "+ _selected +" nakshatra (Birth Star).";
                    _keywords = "baby boy names by "+ _selected +" nakshatra";
                    _heading = "Baby Boy Names by Nakshatra";
                }
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ "+ _selected +" Nakshatra Girl Names With Meaning";
                    _metadesc = "Searching for baby girl names by nakshatra? Browse the list of 100+ modern & unique baby girl names by "+ _selected +" nakshatra (Birth Star).";
                    _keywords = "baby girl names by "+ _selected +" nakshatra";
                    _heading = "Baby Girl Names by Nakshatra";
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Unisex Baby Names By Nakshatra with Meaning";
                    _metadesc = "Searching for unisex baby names by nakshatra? Browse a list of modern, unique & most popular unisex baby boy & girl names by nakshatra at FirstCry Parenting";
                    _keywords = "unisex baby names by naskshatra";
                    _heading = "Unisex Baby Names by Nakshatra";
                }
            } else if (_value_3 == 'starting-with') {
                
                Cookies.set("selectedvalstarting", ["all"]);
                Cookies.set("selectedvalgender", _value_2);

                startwith = ["all"];
                gender = [_value_2];
            
                keyname = "Baby Names by Starting with";

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Baby Boy Names by Starting with Letters - FirstCry Parenting";
                    _metadesc = "Looking for unique and popular baby boy names by Starting with letters? Browse a list of 100+ baby boy names with meaning at FirstCry Parenting.";
                    _keywords = "baby boy names starting with letters";
                    _heading = "Baby Boy Names Starting With Letters A to Z";
                } 
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ Baby Girl Names Starting with Letters - FirstCry Parenting";
                    _metadesc = "Looking for unique and popular baby girl names that start with letters? Browse a list of 100+ baby girl names with meaning at FirstCry Parenting.";
                    _keywords = "baby girl names starting with letters";
                    _heading = "Baby Girl Names Starting with Letters A to Z";
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Unisex Baby Names Starting with Letters - FirstCry Parenting";
                    _metadesc = "Looking for unique and popular unisex baby names that start with letters? Browse a list of 100+ baby girls & boys names with meaning at FirstCry Parenting.";
                    _keywords = "unisex baby names starting with letters";
                    _heading = "Unisex Baby Names Starting with Letters A to Z";
                }

            } else if (_value_3 == 'god-goddesses') {

                Cookies.set("selectedvalgod", ["all"]);
                Cookies.set("selectedvalgender", _value_2);

                gender = [_value_2];
                god = ["all"];
            
                keyname = "Hindu Baby Names by God Goddesses";
                _heading = "Baby Names by God Goddesses";

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Hindu Lord Names for Baby Boy with Meaning";
                    _metadesc = "Are you searching for baby names for your baby boy by God Goddesses? FirstCry Parenting brings a list of popular god goddesses names for boys that you can choose from.";
                    _keywords = "baby boy names by God Goddesses";
                    _heading = "Baby Boy Names by God Goddesses";

                } else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ Hindu Goddess Baby Girl Names with Meaning";
                    _metadesc ="Are you searching for baby names for your baby girl inspired by God Goddesses? FirstCry Parenting brings a list of popular goddess names for girls that you can choose from.";
                    _keywords = "baby girl names by goddess";
                    _heading = "Baby Girl Names Inspired by Goddess";
                } else if(_value_2 ==  "unisex") {
                    _pgtitle = "100+ Unisex Baby Names Inspired by God Goddesses with Meaning";
                    _metadesc ="Browse a list of 100+ most popular & trending baby names inspired by God Goddesses with meaning at FirstCry`s baby names finder.";
                    _keywords = "unisex baby names based on god goddesses";
                    _heading = "Unisex Baby Names Inspired by god Goddesses";;
                }
            }

            breadcrum_1 = _genderstr;
            breadcrum_2 = _value_3.charAt(0).toUpperCase() + _value_3.slice(1);
        } else {
            var _selected  = '';
            if(_value_4 !== "page"){
                _selected = _value_4.replace(/\b[a-z]/g, function(letter) {
                    return letter.toUpperCase();
                });
            }
            _selected = _selected.replace("-", " ");

            var _genderstr = _value_2.replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });
            if (_value_3 == 'religion') {
                
                religion = [_value_4];
                gender = [_value_2];
                Cookies.set('selectedvalreligion', _value_4);

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Latest & Popular "+ _selected +" Baby "+ _genderstr +" Names with Meaning";
                    _metadesc = "Looking for "+ _selected + " names for your baby boy? Check out here to get the modern, unique and latest "+ _genderstr +" baby boy names with meaning at FirstCry Parenting.";
                    _keywords = _selected + " baby boy names";
                    _heading = _selected + " Baby Boy Names";

                } 
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ Cute & Modern "+ _selected +" Baby "+ _genderstr +" Names with Meaning";
                    _metadesc = "Looking for "+ _selected +" names for your baby girl? Check out here to get the modern, unique and latest " + _selected +" baby girl names with meaning at FirstCry Parenting." ;
                    _keywords = _selected +" baby girl names";
                    _heading = _selected + " Baby Girl Names";

                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Unisex Baby Names by "+ _selected + " Religion with Meaning";
                    _metadesc = "Browse a list of 100+ most popular and trending unisex baby names based on "+ _selected +" religion with FirstCry`s baby names finder.";
                    _keywords = "unisex baby names by "+ _selected + " religion";
                    _heading = "Unisex Baby Names by " + _selected +" Religion";
                }
                _descText = "Check out our alphabetical list of 100+ " + _heading + " along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder.";

            } else if (_value_3 == 'origin') {
                origin = [_value_4];
                gender = [_value_2];

                Cookies.set('selectedvalorigin', _value_4);
                keyname = "Baby Names by Origin";

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Latest & Popular " + _selected + " Baby Boy Names with Meaning";
                    _metadesc = "Looking for " + _selected + " names for your baby boy? Check out here to get the modern, unique and latest " + _selected + " baby boy names with meaning at FirstCry Parenting.";
                    _keywords =_selected + " baby boy names";
                    _heading = _selected +  " Baby Boy Names";
                }
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ Cute & Modern " + _selected + " Baby Girl Names with Meaning";
                    _metadesc = "Looking for " + _selected + " names for your baby girl? Check out here to get the modern, unique and latest " + _selected + " baby girl names with meaning at FirstCry Parenting.";
                    _keywords =_selected +  " baby girl names";
                    _heading = _selected +  " Baby Girl Names";
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Popular Unisex Baby Names by "  + _selected +  " Origin with Meanings";
                    _metadesc = "Browse a list of 100 + most popular and trending unisex baby names based on "  + _selected +  " origin with FirstCry`s baby names finder.";
                    _keywords = "unisex names by "  + _selected +  " origin";
                    _heading = "Unisex Baby Names by "+ _selected +" Origin";
                }
                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."

            } else if (_value_3 == 'numerology') {
                numerology = [_value_4];
                gender = [_value_2];
                Cookies.set('selectedvalnumerology', _value_4);
                keyname = "Baby Names By numerology Number (1-9)";
                _heading = "Baby " + _genderstr + " Names by Numerology " + _selected;

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Latest & Popular Baby Boy Names With Numerology Number"+ _selected;
                    _metadesc = "Looking for the lucky baby boy names with Numerology Number "+ _selected + "? Choose from the list of "+ _selected + "+ modern, unique and latest baby boy names at FirstCry Parenting.";
                    _keywords = "baby boy names with Numerology Number "+ _selected;
                    _heading = "Baby Boy Names with Numerology Number "+ _selected;
                }
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ Cute & Modern Baby Girl Names With Numerology Number"+ _selected;
                    _metadesc = "Looking for the lucky baby girl names with Numerology Number "+ _selected + "? Choose from the list of "+ _selected + "+ modern, unique and latest baby girl names at FirstCry Parenting.";
                    _keywords = "baby girl names with Numerology Number "+ _selected;
                    _heading = "Baby Girl Names with Numerology Number "+ _selected;
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Unisex Baby Names by Numerology Number " + _selected +  " with Meanings";
                    _metadesc = "Browse a list of 100+ most popular & trending baby names based on numerology number " + _selected + " with FirstCry`s baby names finder.";
                    _keywords = "unisex baby names based on numerology "+ _selected;
                    _heading = "Unisex Baby Names with Numerology Number "+ _selected;
                }

                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."

            } else if (_value_3 == 'rashi') {
                rashi = [_value_4];
                gender = [_value_2];
                Cookies.set('selectedvalrashi', _value_4);
                keyname = "Baby Names By Hindu Rashi";
                _heading = "Baby " + _genderstr + " Names by Rashi " + _selected;

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ "+ _selected  +" Rashi Baby Boy Names With Meaning";
                    _metadesc = "Are you Looking for "+ _selected  +" rashi baby boy names for your little one? Here are the list of 100+ " + _selected  + " rashi names for boys with their meaning.";
                    _keywords =_selected + " rashi names for boys";
                    _heading = _selected + " Rashi Names for Boys";
                } else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ "+ _selected  +" Rashi Baby Girl Names With Meaning";
                    _metadesc = "Are you Looking for "+ _selected  +" rashi baby girl names for your little one? Here are the list of 100+ " + _selected  + " rashi names for girls with their meaning.";
                    _keywords =_selected + " rashi names for girls";
                    _heading = _selected + " Rashi Names for Girls";
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Unisex Names by " + _selected  + " Rashi with Meaning";
                    _metadesc = "Choose the best unisex baby names by "+ _selected  +" Rashi along with their meanings with FirstCry`s baby name finder at FirstCry Parenting.";
                    _keywords = "unisex baby names by " + _selected  + " Rashi";
                    _heading = "Unisex Baby Names by Hindu " + _selected  + " Rashi";
                }
                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."
            } else if (_value_3 == 'nakshatra') {
                nakshatra = [_value_4];
                gender = [_value_2];
                Cookies.set('selectedvalnakshatra', _value_4);
                keyname = "Hindu Baby Names by Nakshatra";
                _heading = "Baby " + _genderstr + " Names by Nakshatra " + _selected;

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ "+ _selected +" Nakshatra Boy Names With Meaning";
                    _metadesc = "Searching for baby boy names by nakshatra? Browse the list of 100+ modern & unique baby boy names by "+ _selected +" nakshatra (Birth Star).";
                    _keywords = "baby boy names by "+ _selected +" nakshatra";
                    _heading = _selected +" Nakshatra Names for Boys";
                }
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ "+ _selected +" Nakshatra Girl Names With Meaning";
                    _metadesc = "Searching for baby girl names by nakshatra? Browse the list of 100+ modern & unique baby girl names by "+ _selected +" nakshatra (Birth Star).";
                    _keywords = "baby girl names by "+ _selected +" nakshatra";
                    _heading = _selected +" Nakshatra Names for Girls";
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Unisex Baby Names By "+ _selected +" Nakshatra with Meaning";
                    _metadesc = "Searching for unisex baby names by nakshatra? Browse a list of modern, unique & most popular unisex baby boy & girl names by "+ _selected +" nakshatra at FirstCry Parenting";
                    _keywords = "unisex baby names by "+ _selected +" naskshatra";
                    _heading = "Unisex Baby Names by "+ _selected + " Nakshatra";
                }
                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."

            } else if (_value_3 == 'starting-with') {
                startwith = [_value_4];
                gender = [_value_2];
                Cookies.set('selectedvalstarting', _value_4);
                keyname = "Hindu Baby Names by Starting with";

                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ Baby Boy Names Starting with Letters " + _selected +  " - FirstCry Parenting";
                    _metadesc = "Looking for unique and popular baby boy names that start with "  + _selected + "? Browse a list of 100+ baby boy names with meaning at FirstCry Parenting.";
                    _keywords = "Baby Boy Names Starting With Letters A to Z " + _selected ;
                    _heading = "Baby Boy Names Starting with "+ _selected ;
                } 
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ Baby Girl Names Starting with Letters " + _selected +  " - FirstCry Parenting";
                    _metadesc = "Looking for unique and popular baby girl names that start with "  + _selected + "? Browse a list of 100+ baby girl names with meaning at FirstCry Parenting.";
                    _keywords = "baby girl names starting with letters " + _selected ;
                    _heading = "Baby Girl Names Starting with "+ _selected ;
                }
                else if(_value_2 ==  "unisex"){
                    _pgtitle = "100+ Unisex Baby Names Starting with Letters "+ _selected + " - FirstCry Parenting";
                    _metadesc = "Looking for unique and popular unisex baby names that start with "  + _selected +  "? Browse a list of 100+ baby girls & boys names with meaning at FirstCry Parenting.";
                    _keywords = "unisex baby names starting with letters " + _selected ;
                    _heading = "Unisex Baby Names Starting with "+ _selected ;
                }
                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."

            } else if (_value_3 == 'god-goddesses') {
                gender = [_value_2];
                god = [_value_4];
                Cookies.set('selectedvalgod', _value_4);
                keyname = "Hindu Baby Names by God Goddesses";
                _heading = "Baby " + _genderstr + " Names by " + _selected;

                if(_value_2 ==  "boy"){
                    if(_selected == "Lord Krishna" || _selected == "Lord Vishnu" || _selected == "Lord Shiva" || _selected == "Lord Rama" || _selected == "Lord Arjun"){
                        _pgtitle = "100+ Hindu " + _selected  + " Names for Baby Boy with Meaning";
                        _metadesc ="Are you searching for "+ _selected  + " baby names for your baby boy? FirstCry Parenting brings a list of popular "+ _selected  +" names for boys that you can choose from.";
                        _keywords =  _selected  + " baby names for boys";
                        _heading = "Baby Boy Names Inspired by "+ _selected ;

                    } else if(_selected != "Muslim" && _selected != "Sikh") {
                        _pgtitle = "100+ Hindu God " + _selected  + " Names for Baby Boy with Meaning";
                        _metadesc ="Are you searching for god "+ _selected  + " baby names for your baby boy? FirstCry Parenting brings a list of popular god "+ _selected  +" names for boys that you can choose from.";
                        _keywords = "god " + _selected  + " baby names for boys";
                        _heading = "Baby Boy Names Inspired by God "+ _selected ;
                    } else {
                        _pgtitle = "100+ " + _selected  + " Names for Baby Boy with Meaning";
                        _metadesc ="Are you searching for "+ _selected  + " baby names for your baby boy? FirstCry Parenting brings a list of popular "+ _selected  +" names for boys that you can choose from.";
                        _keywords = _selected  + " baby names for boys";
                        _heading = "Baby Boy Names Inspired by "+ _selected ;
                    }

                } else if(_value_2 ==  "girl"){
                    if(_selected == "Lord Krishna" || _selected == "Lord Vishnu" || _selected == "Lord Shiva" || _selected == "Lord Rama" || _selected == "Lord Arjun"){
                        _pgtitle = "100+ Hindu " + _selected  + " Baby Girl Names with Meaning";
                        _metadesc ="Are you searching for "+ _selected  + " baby names for your baby girl? FirstCry Parenting brings a list of popular "+ _selected  +" names for girls that you can choose from.";
                        _keywords = _selected  + " baby girl names";
                        _heading = "Baby Girl Names Inspired by "+ _selected ;
                    } else if(_selected == "Durga"){
                        _pgtitle = "100+ Hindu Goddess " + _selected  + " Baby Girl Names with Meaning";
                        _metadesc ="Are you searching for goddess "+ _selected  + " baby names for your baby girl? FirstCry Parenting brings a list of popular goddess "+ _selected  +" names for girls that you can choose from.";
                        _keywords = "goddess "+_selected  + " baby girl names";
                        _heading = "Baby Girl Names Inspired by Goddess "+ _selected ;
                    } else if(_selected != "Muslim" && _selected != "Sikh") {
                        _pgtitle = "100+ Hindu God " + _selected  + " Names for Baby Girl with Meaning";
                        _metadesc ="Are you searching for god "+ _selected  + " baby names for your baby girl? FirstCry Parenting brings a list of popular god "+ _selected  +" names for boys that you can choose from.";
                        _keywords = "god " + _selected  + " baby names for girls";
                        _heading = "Baby Girl Names Inspired by God "+ _selected ;
                    } else {
                        _pgtitle = "100+ " + _selected  + " Names for Baby Boy with Meaning";
                        _metadesc ="Are you searching for "+ _selected  + " baby names for your baby boy? FirstCry Parenting brings a list of popular "+ _selected  +" names for boys that you can choose from.";
                        _keywords = _selected  + " baby names for boys";
                        _heading = "Baby Boy Names Inspired by "+ _selected ;
                    }
                    
                } else if(_value_2 ==  "unisex") {
                    if(_selected == "Lord Krishna" || _selected == "Lord Vishnu" || _selected == "Lord Shiva" || _selected == "Lord Rama" || _selected == "Lord Arjun"){
                        _pgtitle = "100+ Unisex Baby Names Inspired by " + _selected  + " with Meaning";
                        _metadesc ="Browse a list of 100+ most popular & trending baby names inspired by "+ _selected  +" with meaning at FirstCry`s baby names finder.";
                        _keywords = "unisex baby names based on " + _selected ;
                        _heading = "Unisex Baby Names Inspired by " + _selected ;

                    } else if(_selected == "Durga"){
                        _pgtitle = "100+ Unisex Baby Names Inspired by Goddess " + _selected  + " with Meaning";
                        _metadesc ="Browse a list of 100+ most popular & trending baby names inspired by goddess "+ _selected  +" with meaning at FirstCry`s baby names finder.";
                        _keywords = "unisex baby names based on goddess " + _selected ;
                        _heading = "Unisex Baby Names Inspired by Goddess " + _selected ;
                    } else if(_selected != "Muslim" && _selected != "Sikh") {
                        _pgtitle = "100+ Unisex Baby Names Inspired by God " + _selected  + " with Meaning";
                        _metadesc ="Browse a list of 100+ most popular & trending baby names inspired by god "+ _selected  +" with meaning at FirstCry`s baby names finder.";
                        _keywords = "unisex baby names based on god " + _selected ;
                        _heading = "Unisex Baby Names Inspired by God " + _selected ;
                    } else {
                        _pgtitle = "100+ Unisex Baby Names Inspired by " + _selected  + " with Meaning";
                        _metadesc ="Browse a list of 100+ most popular & trending baby names inspired by "+ _selected  +" with meaning at FirstCry`s baby names finder.";
                        _keywords = "unisex baby names based on " + _selected ;
                        _heading = "Unisex Baby Names Inspired by " + _selected ;
                    }
                }

                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."
            }

            if(_value_5 == 'starting-with') {
                startwith = [_value_6];
                var _selected_ = _value_4.replace(/\b[a-z]/g, function(letter) {
                    return letter.toUpperCase();
                });
                
                if(_value_2 ==  "boy"){
                    _pgtitle = "100+ " + _selected_ +" Baby Boy Names Starting with Letter " + _value_6.toUpperCase() +  " - FirstCry Parenting";
                    _metadesc = "Looking for unique and popular baby boy names that start with "  + _value_6.toUpperCase() + "? Browse a list of 100+ baby boy names with meaning at FirstCry Parenting.";
                    _keywords =  _selected_ + " baby boy names starting with letters " + _value_6.toUpperCase() ;
                    _heading =  _selected_ + " Baby Boy Names Starting with "+ _value_6.toUpperCase() ;
                } 
                else if(_value_2 ==  "girl"){
                    _pgtitle = "100+ " + _selected_ +" Baby Girl Names Starting with Letter " + _value_6.toUpperCase() +  " - FirstCry Parenting";
                    _metadesc = "Looking for unique and popular baby girl names that start with "  + _value_6.toUpperCase() + "? Browse a list of 100+ baby girl names with meaning at FirstCry Parenting.";
                    _keywords = _selected_ +" baby girl names starting with letters " + _value_6.toUpperCase() ;
                    _heading = _selected_ +" Baby Girl Names Starting with "+ _value_6.toUpperCase() ;
                }
                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."
            }

            breadcrum_1 = _genderstr;
            
            breadcrum_2 = _selected;

        }
    }

    else if (_value_2 == 'religion' || _value_2 == 'origin' || _value_2 == 'numerology' || _value_2 == 'rashi' || _value_2 == 'nakshatra' || _value_2 == 'god-goddesses' || _value_2 == 'starting-with' ) {
    
        var CatValue = '';
        if(_value_3 && _value_3 !== "amp"){
            if (_value_3 == "page") {
                pageno = _value_4;
            } else if(_value_4 == "page" && !_value_3.includes("?")){
                pageno = _value_5;
                var CatValue = _value_3;
            } else if(!_value_3.includes("?")){
                pageno = 1;
                var CatValue = _value_3;
            }
        } else {
            pageno = 1;
        }

        if(CatValue == ''){
            var Selected_filter = _value_2.replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });

            if (_value_2 == 'religion') {
                religion = ["all"];
                _pgtitle = "Religious Baby Names for Boys & Girls with Meanings";
                _metadesc = "Looking for religious names for your baby? Find out here and get the best religious baby boy and girl names along with meaning at FirstCry`s Baby Names Finder.";
                _keywords = "Baby names by religion";
                _heading = "Religious Baby Names";

            } else if (_value_2 == 'origin') {
                origin = ["all"];
                Cookies.set('selectedvalorigin', origin);

                _pgtitle = "Baby Names by Origin with Meanings";
                _metadesc = "Choose the best baby girl and boy names by origin along with their meaning using our baby names finder at FirstCry`s Baby Names Finder.";
                _keywords = "Baby names by Origin";
                _heading = "Baby Names By Origin";

            } else if (_value_2 == 'numerology') {
                numerology = ["all"];
        
                _pgtitle = "100+ Baby Names with Numerology Number (1-9) - FirstCry Parenting";
                _metadesc = "Find out the best baby names based on numerology for your baby girls and boys with their meaning from a comprehensive list of baby names at FirstCry Parenting";
                _keywords = "baby names based on numerology";
                _heading = "Baby Names with Numerology Number (1-9)";

            } else if (_value_2 == 'rashi') {

                rashi = ["all"];
                _heading = "Baby Names by Rashi";
                _pgtitle = "100+ Baby Names by Hindu Rashi (Zodiac Signs) - FirstCry Parenting";
                _metadesc = "Choose the best baby girl and boy names by Hindu rashi (Zodiac Signs) along with their meanings with FirstCry`s baby name finder at FirstCry Parenting.";
                _keywords = "baby names by rashi";
                _heading = "Baby Names by Hindu Rashi";
            } else if (_value_2 == 'nakshatra') {
                keyname = "Hindu Baby Names by Nakshatra";

                nakshatra = ["all"];

                _pgtitle = "100+ Hindu Baby Names By Nakshatra (Birth Star) with Meaning";
                _metadesc = "Searching for baby names by nakshatra? Browse a list of modern, unique & most popular Hindu baby boy & girl names by nakshatra (Birth Star) at FirstCry Parenting";
                _keywords = "baby names by naskshatra";
                _heading = "Baby Names by Nakshatra";

            } else if (_value_2 == 'god-goddesses') {       
                gender = ["Boy", "Girl","Unisex"];
                religion =  ["Hindu"];
                category = ["God"];

                _pgtitle = "100+ Popular Baby Names Based on Hindu God & Goddesses With Meaning";
                _metadesc ="Browse a list of 100+ most popular, unique and mythological baby names inspired by Hindu god-goddesses with FirstCry`s baby names finder.";
                _heading = "Baby Names Inspired by Hindu God & Goddesses";
                _keywords = "baby names by god-goddesses";

            } else if (_value_2 == 'starting-with') {
                startwith = ["all"];
                
                _pgtitle = "100+ Baby Names Starting with Letters A-Z - FirstCry Parenting";
                _metadesc = "Browse alphabetical list of 100+ latest and most popular baby boy & girl names starting with A to Z letters with FirstCry`s Baby Name Finder.";
                _keywords = "baby names starting with letters a-z";
                _heading = "Baby Names Starting with Letters A-Z";
            }

            breadcrum_1 = Selected_filter;
        } else {
            var _selected  = '';
            _selected = _value_3.replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });
            _selected = _selected.replace("-", " ");

            var Selected_filter = _value_2.replace(/\b[a-z]/g, function(letter) {
                return letter.toUpperCase();
            });

            if (_value_2 == 'religion') {
                religion = [_value_3];
            
                keyname = "Baby Names By religion";

                _pgtitle = "100+ Latest & Modern " + _selected +" Baby Names with Meaning";
                _metadesc = "Looking for "+ _selected +" names for your baby? Check out here to get the modern, unique and latest " +_selected + " baby boy & girl names with meanings at FirstCry Parenting.";
                _keywords = _selected + " baby names, "+ _selected + " baby boy names, "+ _selected + " baby girl names" ;
                _heading = _selected + " Baby Names";
                
                _descText = "The arrival of a newborn marks a new beginning in every parent`s life. Whether the new ones enter the parents’ lives after years of longing or as a surprise, its an atmosphere of joy and celebrations. " + _heading + " need not be old-fashioned and outdated! Check out our alphabetical list of 100+ " + _heading + " along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder.";
                
            } else if (_value_2 == 'origin') {
                origin = [_value_3];
            
                keyname = "Baby Names by Origin";

                _pgtitle = "100+ Latest & Popular " + _selected +  " Baby Names for Boys & Girls";
                _metadesc = "Looking for "+ _selected + " names for your baby? Check out here to get the modern, unique and latest " + _selected +  " baby boy & girl names with meanings at FirstCry Parenting.";
                _keywords =  _selected + " baby names, "+ _selected + " baby boy names, "+ _selected + " baby girl names" ;
                _heading =  _selected + " Baby Names";

                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."

            } else if (_value_2 == 'numerology') {
                numerology = [_value_3];
                
                keyname = "Baby Names By numerology Number (1-9)";

                _pgtitle = "100+ Lucky Baby Names With Numerology Number "+ _selected + " with Meaning";
                _metadesc = "Looking for the lucky baby names with Numerology Number "+ _selected + "? Choose from the list of 100+ baby names for your baby boy & girls at FirstCry Parenting.";
                _keywords = "baby names for Numerology Number " + _selected;
                _heading = "Baby Names with Numerology Number "+ _selected;

                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."

            } else if (_value_2 == 'rashi') {

                rashi = [_value_3];
                
                keyname = "Baby Names By Hindu Rashi";

                _pgtitle = "100+ "+ _selected +" Rashi Names for Baby Boys & Girls - FirstCry Parenting";
                _metadesc = "Are you Looking for "+ _selected +" rashi baby names for your little one? Here are the list of 100+ "+ _selected +" rashi names for your girl & boy with their meaning.";
                _keywords = _selected + " rashi names for boys," + _selected +  " rashi names for girls";
                _heading = _selected + " Rashi Names for Baby Boys & Girls";
                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."

            } else if (_value_2 == 'nakshatra') {
                nakshatra = [_value_3];
            
                keyname = "Hindu Baby Names by Nakshatra";

                _pgtitle = "100+ " + _selected +  " Nakshatra Names for Baby Boy & Girl With Meaning";
                _metadesc = "Searching for baby names by nakshatra? Browse the list of 100+ modern & unique baby girl & boy names by " + _selected +  " nakshatra (Birth Star).";
                _keywords = "baby names by "+ _selected + " nakshatra";
                _heading = _selected + " Nakshatra Names for Baby Boys & Girls";

                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."

            } else if (_value_2 == 'god-goddesses') {
                god = [_value_3];
                if(_selected == "Lord Krishna" || _selected == "Lord Vishnu" || _selected == "Lord Shiva" || _selected == "Lord Rama" || _selected == "Lord Arjun"){
                    _pgtitle = "100+ Hindu " + _selected + " Baby Names with Meaning";          
                    _metadesc ="Are you searching for " + _selected +" baby names? FirstCry Parenting brings a list of popular " + _selected +" names for baby girls that you can choose from.";
                    _keywords = _selected + " baby names";
                    _heading = "Baby Names Inspired by "+ _selected;
                } else if(_selected == "Durga"){
                    _pgtitle = "100+ Hindu Goddess " + _selected + " Baby Names with Meaning";          
                    _metadesc ="Are you searching for goddess " + _selected +" baby names? FirstCry Parenting brings a list of popular goddess " + _selected +" names for baby girls that you can choose from.";                 
                    _keywords = "goddess " + _selected + " baby names";
                    _heading = "Baby Names Inspired by Goddess "+ _selected;
                } else if(_selected != "Muslim" && _selected != "Sikh") {
                    _pgtitle = "100+ Hindu God " + _selected + " Baby Names with Meaning";          
                    _metadesc ="Are you searching for God " + _selected +" baby names? FirstCry Parenting brings a list of popular God " + _selected +" names for baby boys that you can choose from.";                 
                    _keywords = "God " + _selected + " baby names";
                    _heading = "Baby Names Inspired by God " + _selected;
                } else {
                    _pgtitle = "100+ " + _selected + " Baby Names with Meaning";          
                    _metadesc ="Are you searching for " + _selected +" baby names? FirstCry Parenting brings a list of popular " + _selected +" names for baby boys that you can choose from.";                 
                    _keywords = _selected + " baby names";
                    _heading = "Baby Names Inspired by " + _selected;
                }

                _descText = "Check out our alphabetical list of  100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."

            } else if (_value_2 == 'starting-with') {
                startwith = [_value_3];
            
                keyname = "Hindu Baby Names by Staring With";

                _pgtitle = "100+ Baby Names Starting with Letters " + _selected + " - FirstCry Parenting";
                _metadesc = "Looking for unique and popular baby names that start with " + _selected + "? Browse a list of 100+ baby girls & boys names with meaning at FirstCry Parenting.";
                _keywords = "baby names starting with letters " + _selected;
                _heading = "Baby Names Starting with " + _selected;

                _descText = "Check out our alphabetical list of 100+ "+ _heading +" along with their meanings and choose the best name  for your to be born or newborn baby with the help of  FirstCry`s Baby Names Finder."
            }
            
            breadcrum_1 = Selected_filter;
            breadcrum_2 = _selected;
        }
    }
    else if((_value_2 == 'boy' || _value_2 == 'girl' || _value_2 == 'unisex')){
        
        if (_value_3 == "page") {
            pageno = _value_4;
        } else {
            pageno = 1;
        }
        gender = [_value_2];

        var _genderstr = _value_2.replace(/\b[a-z]/g, function(letter) {
            return letter.toUpperCase();
        });

        Cookies.set('selectedvalgender', _value_2);

        if(_value_2 == "boy"){
            _pgtitle = "100+ Latest & Popular Baby " + _genderstr + " Names with Meanings";
            _metadesc = "Searching for unique baby boy name for your little one? Choose from a a list of latest, trendy & cute baby " + _genderstr + " names for meaning at FirstCry Parenting.";
            _keywords = "baby " + _genderstr + " names, cute "  + _genderstr + " names";
            _heading = "Baby " + _genderstr + " Names";
        } else if(_value_2 == 'girl'){
            _pgtitle = "100+ Cute & Modern Baby " + _genderstr + " Names with Meaning";
            _metadesc = "Searching for unique baby " + _genderstr + " name for your little angel? Choose from a a list of  100+ latest, trendy & cute baby " + _genderstr + " names for meaning at FirstCry Parenting.";
            _keywords = "baby " + _genderstr + " names, cute "  + _genderstr + " names";
            _heading = "Baby " + _genderstr + " Names";
        } else {
            _pgtitle = "100+ Unisex Names for Baby Girls & Boys with Meaning";
            _metadesc = "Searching for unisex baby boy name for your little one? Choose from the list of 100+ unique unisex names for your baby boy & girls at FirstCry Parenting.";
            _keywords = "unisex names, unique unisex names, popular unisex names";
            _heading = "Unisex Names for Baby Girls & Boys";
        }

        breadcrum_1 = _genderstr;
    }
    var returnObject = {
        postDetails : {
            "_descText" : _descText,
            "_breadcrum_1" : breadcrum_1,
            "_breadcrum_2" : breadcrum_2,
            "sortkey" : sortkey,
            "pageno" : pageno,
            "heading" :_heading,
        },
        metaDetails : {
            "pgtitle" : _pgtitle, 
            "metadesc" : _metadesc,
            "keywords" : _keywords,
            "heading" :_heading,
        }
    }
    // console.log(returnObject.postDetails);
    return(returnObject);
}
// pagination



// WEBPACK FOOTER //
// src/shared/baby-names-amp/actions.js